import React, { useState, useEffect, useRef } from "react";
import Jobs_header from '../Header/Jobs_header'
import back_arrow from "../../assets/svg/back-arrow.svg";
import { useNavigate } from "react-router-dom";
import "../../styles/Jobs.css"
import upload_icon from "../../assets/svg/upload_icon.svg";
import excel_icon from "../../assets/svg/excel_icon.svg";
import small_line from "../../assets/svg/small_line.svg";
import delete_icon from "../../assets/svg/delete_icon.svg";
import plus_icon from "../../assets/svg/plus_icon.svg";
import plus_circle from "../../assets/svg/plus-circle.svg";
import split from "../../assets/svg/split.svg";
import sales from "../../assets/svg/sales.svg";
import cost from "../../assets/svg/cost.svg";
import split_hover from "../../assets/svg/split-b.svg";
import sales_hover from "../../assets/svg/sales-b.svg";
import cost_hover from "../../assets/svg/cost-b.svg";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import download_arrow from "../../assets/svg/download_arrow.svg"
import AsyncSelect from 'react-select/async';
import axiosInstance from "../../axiosInstance";
import { useSearchParams } from 'react-router-dom';
import { usePermissions } from "../../hooks/PermissionContext";
import AdditionalPermissionWrapper from "../../hooks/AdditionalPermissionWrapper";
import arrow_horizontal from "../../assets/svg/arrow-horizontal.svg";
import DraggableDivider from "../Jobs/DraggableDivider";
import ConfirmDialog from "../../ConfirmDialog/ConfirmDialog";
import CommonFooter from "../../CommonFooter/CommonFooter";
import useAttachmentValidator from "../../Component/AttachmentValidator/AttachmentValidator";
import { SquarePen } from "lucide-react";
import CommonRemarkPopup from "../../CommonRemarkPopup/CommonRemarkPopup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Jobs_addnew = ({ id }) => {

  let ModuleId = 23
  const { getModulePermission } = usePermissions();
  const permission = getModulePermission(ModuleId);
  console.log("activeModuleId", ModuleId);

  console.log("permission", permission);
  const { hasAdditionalPermission } = usePermissions();
  // const canEditCharges = hasAdditionalPermission(ModuleId, "rev_edit_contract_charges");
  // console.log("canEditCharges", canEditCharges);
  const { validateAttachments } = useAttachmentValidator();

  const [isUploadPopupOpen, setIsUploadPopupOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState("");
  const [selectedproject, setselectedproject] = useState(0);

  const [selectedJobs, setSelectedJobs] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [isJobDropdownOpen, setIsJobDropdownOpen] = useState(false);
  const [showProjectSuggestions, setShowProjectSuggestions] = useState(false);
  const dropdownRef = useRef(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [jobOptions, setJobOptions] = useState([]);
  const [suggestionsMap, setSuggestionsMap] = useState({}); // index => suggestions
  const [showSuggestionsMap, setShowSuggestionsMap] = useState({});
  const [projectInput, setProjectInput] = useState("");
  const [inputValues, setInputValues] = useState({});

  const [projectId, setselectedprojectId] = useState(0);
  const [selectedChargeIds, setSelectedChargeIds] = useState({});


  const [isEdit, setIsEdit] = useState(false);
  const [hasProjectChanged, setHasProjectChanged] = useState(false);

  const [jobId, setJobId] = useState(0);

  const [jobid, setjobid] = useState(0);
  const [vendorSuggestions, setVendorSuggestions] = useState([]);
  const [showVendorSuggestions, setShowVendorSuggestions] = useState({});
  const [vendorInputValues, setVendorInputValues] = useState({});
  const [selectedVendorIds, setSelectedVendorIds] = useState({});
  const [salesInputValues, setSalesInputValues] = useState({});
  const [costInputValues, setCostInputValues] = useState({});
  const [selectedSalesChargeIds, setSelectedSalesChargeIds] = useState({});
  const [selectedCostChargeIds, setSelectedCostChargeIds] = useState({});
  const [salesSuggestionsMap, setSalesSuggestionsMap] = useState({});
  const [costSuggestionsMap, setCostSuggestionsMap] = useState({});
  const [showSalesSuggestionsMap, setShowSalesSuggestionsMap] = useState({});
  const [showCostSuggestionsMap, setShowCostSuggestionsMap] = useState({});
  const [openConfirm, setOpenConfirm] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [openConfirmUpdate, setOpenConfirmUpdate] = useState(false);
  const [pendingUpdateAction, setPendingUpdateAction] = useState(null);
  const [showRemarkPopup, setShowRemarkPopup] = useState(false);
  const [remarkValue, setRemarkValue] = useState("");
  const [remarkMeta, setRemarkMeta] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [jobTypesWithDivision, setJobTypesWithDivision] = useState([]);
  const [plantCode, setPlantCode] = useState(null);
  const [projectPlantId, setProjectPlantId] = useState(null);
  const [plantCodeOptions, setPlantCodeOptions] = useState([]);
  const salesRef = useRef(null);
  const costRef = useRef(null);
  const [viewModes, setViewModes] = useState({});
  const navigate = useNavigate();
  const locationData = useLocation();
  const job_data = locationData.state?.job_data || {};
  const data = job_data?.data || {};

  const [deletedSalesLineIds, setDeletedSalesLineIds] = useState([]);
  const [deletedCostLineIds, setDeletedCostLineIds] = useState([]);

  const contract_id = data.contract_id;
  console.log("contract_id", contract_id);


  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
    console.log("data", data);
  }, [data?.job_id]);


  // Edit
  useEffect(() => {
    console.log("Edit use effect called with data:", data);

    const loadEditData = async () => {
      try {
        if (data && Object.keys(data).length > 0) {
          console.log("inside of data use effect");
          setIsEdit(true);
          setjobid(data.job_id);
          setPlantCode({
            label: data.ff_plant_code,
            value: data.ff_plant_id
          });
          setFormData({
            project_id: data.project_id || "",
            job_no: data.job_no || "",
            job_type_id: data.job_type_id || "",
            job_created_date: data.created_date?.split(" ")[0] || '',
            total_sales_accrual: data.total_sales_accrual || "0",
            total_cost_accrual: data.total_cost_accrual || "0",
            supply_period: data.supply_period
              ? new Date(data.supply_period)
              : null,
          });

          console.log("Form data set to:", data.project_id, data.job_type_id);

          // Load project options
          const projectResponse = await axiosInstance.get(
            "/costsolution/projects/autosuggestion",
            { params: { query: "" } }
          );

          if (projectResponse.data?.autosuggestion) {
            const options = projectResponse.data.autosuggestion;
            setProjectOptions(options);

            const selected = options.find(item => item.value === data.project_id);
            if (selected) {
              setProjectInput(selected.label);
              setselectedproject(selected.value);
              setselectedprojectId(selected.value);
            }
          }

          // Load job types for the project
          if (data.project_id) {
            const jobResponse = await axiosInstance.get(
              `/project_based/getJobTypes/${data.project_id}`
            );

            if (jobResponse.data && Array.isArray(jobResponse.data.jobtypes)) {
              setJobOptions(jobResponse.data.jobtypes);
            }
          }

          // Process sales_lines and cost_lines into salesRows and costRows
          if ((data.sales_lines || data.cost_lines) && !hasProjectChanged) {
            let mappedCategories = [{
              id: data.job_type_id,
              name: data.job_type_name || "",
              salesRows: data.sales_lines ? data.sales_lines.map((line, index) => ({
                job_sales_line_id: line.id,
                charge_id: line.charge_id,
                description: line.description_of_charges || "",
                SalesunitQuantity: parseFloat(line.unit_of_quantity) || 0,
                salesRemarks: line.remarks || "",
                salesRate: parseFloat(line.unit_of_rate) || 0,
                salesNetTotal: parseFloat(line.net_total) || 0,
                salesContractValue: parseFloat(line.contract_value) || 0,
                chargecode: line.charge_code || "",
                attachment_urls: { sales: line.attachment_url || null },
                salesUploadedFiles: [],
                salesAttachment: line.attachment_url || "",
                sales_status: line.sales_status || null,
                sales_invoice_status: line.sales_invoice_status || null,
                po_wo_number: line.po_wo_number || null,
                po_wo_date: line.po_wo_date || null
              })) : [],
              costRows: data.cost_lines ? data.cost_lines.map((line, index) => ({
                job_cost_line_id: line.id,
                charge_id: line.charge_id,
                description: line.description_of_charges || "",
                CostunitQuantity: parseFloat(line.unit_of_quantity) || 0,
                costRemarks: line.remarks || "",
                vendor_name: line.vendor_name || "",
                vendor_id: line.vendor_id || 0,
                vendor_inv_number: line.vendor_inv_number || "",
                vendor_inv_date: line.vendor_inv_date || null,
                costRate: parseFloat(line.unit_of_rate) || 0,
                costNetTotal: parseFloat(line.net_total) || 0,
                costContractValue: parseFloat(line.contract_value) || 0,
                chargecode: line.charge_code || "",
                attachment_urls: { cost: line.attachment_url || null },
                costUploadedFiles: [],
                costAttachment: line.attachment_url || "",
                cost_status: line.cost_status || null,
                cost_invoice_status: line.cost_invoice_status || null,
                po_wo_number: line.po_wo_number || null,
                po_wo_date: line.po_wo_date || null
              })) : []
            }];

            console.log("mapped categories.........", mappedCategories);

            const salesChargeCodeResponse = await axiosInstance.get(
              `/getnonprojectsaleschargecodes`
            );

            const costChargeCodeResponse = await axiosInstance.get(
              `/getnonprojectcostchargecodes`
            );


            if (salesChargeCodeResponse.data?.chargecodes && costChargeCodeResponse.data?.chargecodes) {
              console.log("inside charge code");
              console.log("Sales Charge Code List:", salesChargeCodeResponse.data.chargecodes);
              console.log("Cost Charge Code List:", costChargeCodeResponse.data.chargecodes);

              const salesChargeList = salesChargeCodeResponse.data.chargecodes;
              const costChargeList = costChargeCodeResponse.data.chargecodes;

              mappedCategories = mappedCategories.map(category => {
                const updatedSalesRows = category.salesRows.map(row => {
                  const matched = salesChargeList.find(code => Number(code.value) === Number(row.charge_id));
                  return {
                    ...row,
                    chargecode: matched ? matched.label : row.chargecode
                  };
                });

                const updatedCostRows = category.costRows.map(row => {
                  const matched = costChargeList.find(code => Number(code.value) === Number(row.charge_id));
                  return {
                    ...row,
                    chargecode: matched ? matched.label : row.chargecode
                  };
                });

                return {
                  ...category,
                  salesRows: updatedSalesRows,
                  costRows: updatedCostRows
                };
              });

              // Calculate totals for each category
              mappedCategories = mappedCategories.map(category => {
                const salesNetTotal = category.salesRows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0);
                const costNetTotal = category.costRows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0);
                const profitAmount = salesNetTotal - costNetTotal;
                const profitPercent = costNetTotal > 0
                  ? ((profitAmount / costNetTotal) * 100).toFixed(2)
                  : '0.00';

                return {
                  ...category,
                  salesNetTotal: salesNetTotal.toFixed(2),
                  costNetTotal: costNetTotal.toFixed(2),
                  profitAmount: profitAmount.toFixed(2),
                  profitPercent
                };
              });

              console.log("Mapped Categories with Totals:", mappedCategories);
            }

            setAllCategories(mappedCategories);
            setSelectedJobs([data.job_type_id]);
            console.log("selectedJobs updated: ", [data.job_type_id]);

            // Initialize input values and charge IDs
            const initialSalesInputValues = {};
            const initialCostInputValues = {};
            const initialSelectedSalesChargeIds = {};
            const initialSelectedCostChargeIds = {};

            mappedCategories.forEach((category, catIndex) => {
              initialSalesInputValues[catIndex] = {};
              initialCostInputValues[catIndex] = {};

              // Sales rows
              category.salesRows.forEach((row, rowIndex) => {
                initialSalesInputValues[catIndex][rowIndex] = row.chargecode || "";
                initialSelectedSalesChargeIds[`${catIndex}_${rowIndex}`] = row.charge_id || 0;
              });

              // Cost rows
              category.costRows.forEach((row, rowIndex) => {
                initialCostInputValues[catIndex][rowIndex] = row.chargecode || "";
                initialSelectedCostChargeIds[`${catIndex}_${rowIndex}`] = row.charge_id || 0;
              });
            });

            setSalesInputValues(initialSalesInputValues);
            setCostInputValues(initialCostInputValues);
            setSelectedSalesChargeIds(initialSelectedSalesChargeIds);
            setSelectedCostChargeIds(initialSelectedCostChargeIds);

            // Initialize vendor input values and IDs
            const initialVendorInputValues = {};
            const initialSelectedVendorIds = {};
            mappedCategories.forEach((category, catIndex) => {
              category.costRows.forEach((row, rowIndex) => {
                const key = `${catIndex}_${rowIndex}`;
                initialVendorInputValues[key] = row.vendor_name || "";
                initialSelectedVendorIds[key] = row.vendor_id || 0;
              });
            });
            setVendorInputValues(initialVendorInputValues);
            setSelectedVendorIds(initialSelectedVendorIds);
          }
        }
      } catch (error) {
        console.error("Error loading edit data:", error);
      }
    };

    loadEditData();
  }, [data?.job_id]);


  const loadProjectOptions = async (inputValue, callback) => {
    console.log("Searching for projects with:", inputValue);

    try {
      const res = await axiosInstance.get(
        "/costsolution/projects/autosuggestion",
        {
          params: { term: inputValue || '' },
        }
      );

      const projects = res.data?.autosuggestion || [];

      const filtered = projects.filter(item =>
        item.label.toUpperCase().includes(inputValue.toUpperCase())
      );

      const mapped = filtered.map((item) => ({
        label: item.label,
        value: item.value,
        plant_id: item.plant_id
      }));

      console.log("Filtered + Mapped project options:", mapped);
      callback(mapped);
    } catch (error) {
      console.error("Project suggestion error:", error);
      callback([]);
    }
  };


  const jobData = [
    {
      id: "83939930",
      name: "83939930",
      categories: [
        {
          id: 1,
          name: "Category 1",
          quantity: 340,
          rate: 45000,
          netValue: 67000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        },
      ]
    },
    {
      id: "53939930",
      name: "53939930",
      categories: [
        {
          id: 2,
          name: "Category 2",
          quantity: 210,
          rate: 32000,
          netValue: 67200,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        }
      ]
    },
    {
      id: "23939930",
      name: "23939930",
      categories: [
        {
          id: 3,
          name: "Category 3",
          quantity: 150,
          rate: 28000,
          netValue: 42000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        }
      ]
    },
    {
      id: "743930290",
      name: "743930290",
      categories: [
        {
          id: 4,
          name: "Category 4",
          quantity: 150,
          rate: 28000,
          netValue: 42000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        }
      ]
    },
    {
      id: "938493809",
      name: "938493809",
      categories: [
        {
          id: 5,
          name: "Category 5",
          quantity: 150,
          rate: 28000,
          netValue: 42000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        },

      ]
    },
    {
      id: "793849380",
      name: "793849380",
      categories: [
        {
          id: 6,
          name: "Category 6",
          quantity: 340,
          rate: 45000,
          netValue: 67000,
          rows: [
            {
              billingtype: "",
              elements: "",
              remarks: "",
              description: "",
              unitQuantity: "",
              unitRatePrice: "",
              netTotal: "",
              attachment: "",
              uploadedFiles: [],
              isChecked: false,
            }
          ]
        }
      ]
    },
  ];

  const [allCategories, setAllCategories] = useState([]);

  // When selected jobs change, update the categories
  useEffect(() => {
    const newCategories = [];
    selectedJobs.forEach(jobId => {
      const job = jobData.find(j => j.id === jobId);
      if (job) {
        newCategories.push(...job.categories);
      }
    });
    setAllCategories(newCategories);
  }, [selectedJobs]);

  const handleJobSelection = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map(option => option.value);
    setSelectedJobs(selectedOptions);
  };

  const handleRemoveJob = (jobIdToRemove) => {
    setSelectedJobs(prevSelectedJobs => {
      const jobIndexToRemove = prevSelectedJobs.findIndex(id => id === jobIdToRemove);

      // Remove categories
      setAllCategories(prev => {
        const jobToRemove = jobData.find(j => j.id === jobIdToRemove);
        if (!jobToRemove) return prev;

        const categoryIdsToRemove = jobToRemove.categories.map(c => c.id);
        return prev.filter(cat => !categoryIdsToRemove.includes(cat.id));
      });

      // Clear charge code input fields
      setInputValues(prev => {
        const newInputValues = { ...prev };
        delete newInputValues[jobIndexToRemove];
        return newInputValues;
      });

      // Clear selected charge IDs
      setSelectedChargeIds(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(key => {
          if (key.startsWith(`${jobIndexToRemove}_`)) {
            delete updated[key];
          }
        });
        return updated;
      });

      // Clear suggestion visibility map
      setShowSuggestionsMap(prev => {
        const updated = { ...prev };
        Object.keys(updated).forEach(key => {
          if (key.startsWith(`${jobIndexToRemove}_`)) {
            delete updated[key];
          }
        });
        return updated;
      });

      // Return updated job selection
      return prevSelectedJobs.filter(id => id !== jobIdToRemove);
    });
  };


  const handleAttachFileUpload = (e) => {
    const files = Array.from(e.target.files);
    setUploadedFiles([...uploadedFiles, ...files]);
  };

  const handleAttachRemoveFile = (index) => {
    const newFiles = [...uploadedFiles];
    newFiles.splice(index, 1);
    setUploadedFiles(newFiles);
  };

  const addSalesRow = (categoryId) => {
    setAllCategories(prevCategories =>
      prevCategories.map((category) =>
        category.id === categoryId
          ? {
            ...category,
            salesRows: [
              ...category.salesRows,
              {
                chargecode: "",
                description: "",
                SalesunitQuantity: '',
                salesRemarks: '',
                salesRate: '',
                salesContractValue: '0.00',
                salesNetTotal: '0.00',
                salesUploadedFiles: [],
                profitAmount: '0.00',
                profitPercent: '0.00',
                uploadedFiles: [],
                isSales: true,
                po_wo_number: null,
                po_wo_date: null
              },
            ],
          }
          : category
      )
    );
  };

  const addCostRow = (categoryId) => {
    setAllCategories(prevCategories =>
      prevCategories.map((category) =>
        category.id === categoryId
          ? {
            ...category,
            costRows: [
              ...category.costRows,
              {
                chargecode: "",
                description: "",
                costRemarks: '',
                CostunitQuantity: '',
                costRate: '',
                costNetTotal: '0.00',
                costUploadedFiles: [],
                costContractValue: '0.00',
                vendor_id: 0,
                vendor_inv_number: "",
                vendor_inv_date: null,
                po_wo_number: null,
                po_wo_date: null
              },
            ],
          }
          : category
      )
    );
  };


  const handleSalesFileUpload = (e, categoryId, index, lineindex) => {
    const files = validateAttachments(e.target.files);
    if (!files.length) return;
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            salesRows: category.salesRows.map((row, i) =>
              i === lineindex
                ? {
                  ...row,
                  salesUploadedFiles: [...(row.salesUploadedFiles || []), ...files],
                  salesAttachment: "", // clear existing
                  attachment_urls: {
                    ...row.attachment_urls,
                    sales: null
                  }
                }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleCostFileUpload = (e, categoryId, index, lineindex) => {
    const files = validateAttachments(e.target.files);
    if (!files.length) return;
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            costRows: category.costRows.map((row, i) =>
              i === lineindex
                ? {
                  ...row,
                  costUploadedFiles: [...(row.costUploadedFiles || []), ...files],
                  costAttachment: "", // clear existing
                  attachment_urls: {
                    ...row.attachment_urls,
                    cost: null
                  }
                }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleRemoveSalesFile = (categoryId, index, lineindex, fileIndex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            salesRows: category.salesRows.map((row, i) =>
              i === lineindex
                ? {
                  ...row,
                  salesUploadedFiles: row.salesUploadedFiles.filter((_, idx) => idx !== fileIndex),
                }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleRemoveCostFile = (categoryId, index, lineindex, fileIndex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            costRows: category.costRows.map((row, i) =>
              i === lineindex
                ? {
                  ...row,
                  costUploadedFiles: row.costUploadedFiles.filter((_, idx) => idx !== fileIndex),
                }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleRemoveSalesAttachment = (categoryId, index, lineindex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            salesRows: category.salesRows.map((row, i) =>
              i === lineindex
                ? {
                  ...row,
                  salesAttachment: "",
                  attachment_urls: {
                    ...row.attachment_urls,
                    sales: null
                  }
                }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleRemoveCostAttachment = (categoryId, index, lineindex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            costRows: category.costRows.map((row, i) =>
              i === lineindex
                ? {
                  ...row,
                  costAttachment: "",
                  attachment_urls: {
                    ...row.attachment_urls,
                    cost: null
                  }
                }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleFileUpload = (e, categoryId, index, lineindex) => {
    const files = Array.from(e.target.files);

    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === lineindex
                ? { ...row, uploadedFiles: [...(row.uploadedFiles || []), ...files] }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleRemoveFile = (categoryId, index, lineindex, fileIndex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === lineindex
                ? {
                  ...row,
                  uploadedFiles: row.uploadedFiles.filter((_, idx) => idx !== fileIndex),
                }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleRemoveAttachment = (categoryId, index, lineindex) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === lineindex
                ? { ...row, attachment: "" }
                : row
            ),
          }
          : category
      )
    );
  };

  const handleSalesInputChange = (e, categoryIndex, rowIndex, field) => {
    let value = e.target.value;

    if (field === "salesRemarks") {
      value = value.replace(/,/g, "");
    }

    setAllCategories(prevCategories =>
      prevCategories.map((category, currentIndex) => {
        if (currentIndex === categoryIndex) {
          const updatedSalesRows = category.salesRows.map((row, i) => {
            if (i === rowIndex) {
              const updatedRow = { ...row, [field]: value };

              // Recalculate salesNetTotal when quantity or rate changes
              if (field === 'SalesunitQuantity' || field === 'salesRate') {
                const salesQuantity = parseFloat(updatedRow.SalesunitQuantity) || 0;
                const salesRate = parseFloat(updatedRow.salesRate) || 0;
                updatedRow.salesNetTotal = (salesQuantity * salesRate).toFixed(2);
              }

              return updatedRow;
            }
            return row;
          });

          // After updating, recalculate category totals including profit
          const salesNetTotal = updatedSalesRows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0);
          const costNetTotal = category.costRows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0);
          const profitAmount = salesNetTotal - costNetTotal;
          const profitPercent = costNetTotal > 0
            ? ((profitAmount / costNetTotal) * 100).toFixed(2)
            : '0.00';

          return {
            ...category,
            salesRows: updatedSalesRows,
            salesNetTotal: salesNetTotal.toFixed(2),
            profitAmount: profitAmount.toFixed(2),
            profitPercent
          };
        }
        return category;
      })
    );
  };

  const handleCostInputChange = (e, categoryIndex, rowIndex, field) => {
    let value = e.target.value;

    if (field === "costRemarks") {
      value = value.replace(/,/g, "");
    }

    setAllCategories(prevCategories =>
      prevCategories.map((category, currentIndex) => {
        if (currentIndex === categoryIndex) {
          const updatedCostRows = category.costRows.map((row, i) => {
            if (i === rowIndex) {
              const updatedRow = { ...row, [field]: value };

              // Recalculate costNetTotal when quantity or rate changes
              if (field === 'CostunitQuantity' || field === 'costRate') {
                const costQuantity = parseFloat(updatedRow.CostunitQuantity) || 0;
                const costRate = parseFloat(updatedRow.costRate) || 0;
                updatedRow.costNetTotal = (costQuantity * costRate).toFixed(2);
              }

              return updatedRow;
            }
            return row;
          });

          // After updating, recalculate category totals including profit
          const costNetTotal = updatedCostRows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0);
          const salesNetTotal = category.salesRows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0);
          const profitAmount = salesNetTotal - costNetTotal;
          const profitPercent = costNetTotal > 0
            ? ((profitAmount / costNetTotal) * 100).toFixed(2)
            : '0.00';

          return {
            ...category,
            costRows: updatedCostRows,
            costNetTotal: costNetTotal.toFixed(2),
            profitAmount: profitAmount.toFixed(2),
            profitPercent
          };
        }
        return category;
      })
    );
  };


  const handleCheckboxChange = (e, categoryId, index) => {
    setAllCategories(prevCategories =>
      prevCategories.map(category =>
        category.id === categoryId
          ? {
            ...category,
            rows: category.rows.map((row, i) =>
              i === index ? { ...row, isChecked: e.target.checked } : row
            ),
          }
          : category
      )
    );
  };

  const deleteRow = (categoryId, rowIndex, rowType) => {
    const categoryIndex = allCategories.findIndex(cat => cat.id === categoryId);

    if (categoryIndex === -1) {
      return;
    }

    const category = allCategories[categoryIndex];

    // Check if we're deleting from sales or cost rows
    const isSalesRow = rowType === 'sales';
    const targetRows = isSalesRow ? category.salesRows : category.costRows;

    if (targetRows.length <= 1) {
      toast.error("At least one row must remain, cannot delete.");
      return;
    }

    setAllCategories(prevCategories =>
      prevCategories.map(cat => {
        if (cat.id === categoryId) {
          // Create new arrays without the deleted row
          const newSalesRows = isSalesRow
            ? [...cat.salesRows].filter((_, i) => i !== rowIndex)
            : [...cat.salesRows];

          const newCostRows = !isSalesRow
            ? [...cat.costRows].filter((_, i) => i !== rowIndex)
            : [...cat.costRows];

          // Calculate new totals
          const salesNetTotal = newSalesRows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0);
          const costNetTotal = newCostRows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0);
          const profitAmount = salesNetTotal - costNetTotal;
          const profitPercent = costNetTotal > 0
            ? ((profitAmount / costNetTotal) * 100).toFixed(2)
            : '0.00';

          return {
            ...cat,
            salesRows: newSalesRows,
            costRows: newCostRows,
            salesNetTotal: salesNetTotal.toFixed(2),
            costNetTotal: costNetTotal.toFixed(2),
            profitAmount: profitAmount.toFixed(2),
            profitPercent
          };
        }
        return cat;
      })
    );

    // Update input values state
    if (isSalesRow) {
      setSalesInputValues(prevInputValues => {
        const newInputValues = { ...prevInputValues };
        if (newInputValues[categoryIndex]) {
          const rows = { ...newInputValues[categoryIndex] };
          delete rows[rowIndex];
          const shiftedRows = {};
          Object.keys(rows).forEach(key => {
            const keyNum = Number(key);
            shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
          });
          newInputValues[categoryIndex] = shiftedRows;
        }
        return newInputValues;
      });

      setSelectedSalesChargeIds(prevSelectedChargeIds => {
        const newSelectedChargeIds = {};
        Object.keys(prevSelectedChargeIds).forEach(key => {
          const [catIndexStr, rowIdxStr] = key.split('_');
          const catIndex = Number(catIndexStr);
          const rowIdx = Number(rowIdxStr);

          if (catIndex === categoryIndex) {
            if (rowIdx < rowIndex) {
              newSelectedChargeIds[key] = prevSelectedChargeIds[key];
            } else if (rowIdx > rowIndex) {
              newSelectedChargeIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedChargeIds[key];
            }
          } else {
            newSelectedChargeIds[key] = prevSelectedChargeIds[key];
          }
        });
        return newSelectedChargeIds;
      });
    } else {
      setCostInputValues(prevInputValues => {
        const newInputValues = { ...prevInputValues };
        if (newInputValues[categoryIndex]) {
          const rows = { ...newInputValues[categoryIndex] };
          delete rows[rowIndex];
          const shiftedRows = {};
          Object.keys(rows).forEach(key => {
            const keyNum = Number(key);
            shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
          });
          newInputValues[categoryIndex] = shiftedRows;
        }
        return newInputValues;
      });

      setSelectedCostChargeIds(prevSelectedChargeIds => {
        const newSelectedChargeIds = {};
        Object.keys(prevSelectedChargeIds).forEach(key => {
          const [catIndexStr, rowIdxStr] = key.split('_');
          const catIndex = Number(catIndexStr);
          const rowIdx = Number(rowIdxStr);

          if (catIndex === categoryIndex) {
            if (rowIdx < rowIndex) {
              newSelectedChargeIds[key] = prevSelectedChargeIds[key];
            } else if (rowIdx > rowIndex) {
              newSelectedChargeIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedChargeIds[key];
            }
          } else {
            newSelectedChargeIds[key] = prevSelectedChargeIds[key];
          }
        });
        return newSelectedChargeIds;
      });

      // Update vendor-related states for cost rows
      setVendorInputValues(prevVendorInputValues => {
        const newVendorInputValues = {};
        Object.keys(prevVendorInputValues).forEach(key => {
          const [catIndexStr, rowIdxStr] = key.split('_');
          const catIndex = Number(catIndexStr);
          const rowIdx = Number(rowIdxStr);

          if (catIndex === categoryIndex) {
            if (rowIdx < rowIndex) {
              newVendorInputValues[key] = prevVendorInputValues[key];
            } else if (rowIdx > rowIndex) {
              newVendorInputValues[`${catIndex}_${rowIdx - 1}`] = prevVendorInputValues[key];
            }
          } else {
            newVendorInputValues[key] = prevVendorInputValues[key];
          }
        });
        return newVendorInputValues;
      });

      setSelectedVendorIds(prevSelectedVendorIds => {
        const newSelectedVendorIds = {};
        Object.keys(prevSelectedVendorIds).forEach(key => {
          const [catIndexStr, rowIdxStr] = key.split('_');
          const catIndex = Number(catIndexStr);
          const rowIdx = Number(rowIdxStr);

          if (catIndex === categoryIndex) {
            if (rowIdx < rowIndex) {
              newSelectedVendorIds[key] = prevSelectedVendorIds[key];
            } else if (rowIdx > rowIndex) {
              newSelectedVendorIds[`${catIndex}_${rowIdx - 1}`] = prevSelectedVendorIds[key];
            }
          } else {
            newSelectedVendorIds[key] = prevSelectedVendorIds[key];
          }
        });
        return newSelectedVendorIds;
      });
    }

    if (isSalesRow) {
      const deletedRow = category.salesRows[rowIndex];
      if (deletedRow?.job_sales_line_id) {
        setDeletedSalesLineIds(prev => [...prev, deletedRow.job_sales_line_id]);
      }
    } else {
      const deletedRow = category.costRows[rowIndex];
      if (deletedRow?.job_cost_line_id) {
        setDeletedCostLineIds(prev => [...prev, deletedRow.job_cost_line_id]);
      }
    }

    // Update suggestions map
    setSuggestionsMap(prev => {
      const newMap = { ...prev };
      if (newMap[categoryIndex]) {
        const rows = { ...newMap[categoryIndex] };
        delete rows[rowIndex];
        const shiftedRows = {};
        Object.keys(rows).forEach(key => {
          const keyNum = Number(key);
          shiftedRows[keyNum > rowIndex ? keyNum - 1 : keyNum] = rows[key];
        });
        newMap[categoryIndex] = shiftedRows;
      }
      return newMap;
    });
  };

  const toggleJobDropdown = () => {
    setIsJobDropdownOpen(!isJobDropdownOpen);
  };

  const handleJobCheckboxChange = (jobId) => {
    if (selectedJobs.includes(jobId)) {
      // Unchecking: cleanup related data
      handleRemoveJob(jobId);
    } else {
      // Selecting: only allow one job type at a time
      if (selectedJobs.length > 0) {
        const prevJobId = selectedJobs[0];
        handleRemoveJob(prevJobId); // remove old one first
      }
      setSelectedJobs([jobId]);

      const selectedJob = jobOptions.find(j => j.value === jobId);

      if (selectedJob?.division_type?.toUpperCase() !== "FF") {
        setPlantCode(null);
      }

    }
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsJobDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const [formData, setFormData] = useState({
    project_id: "",
    job_no: "",
    job_type_id: "",
    job_created_date: "",
    // vendor_code: ""
    supply_period: null
  });

  const handleProjectChange = (e) => {
    setFormData({ ...formData, project_id: e.target.value });
  };

  const handleDateChange = (e) => {
    setFormData({ ...formData, job_created_date: e.target.value });
  };

  const handleSubmit = async (actionType = "submit") => {
    if (isSaving || isSubmitting) return;
    if (!validateCategories()) return;

    if (!projectInput.trim()) {
      toast.error("Project Code is required");
      return;
    }
    if (selectedJobs.length === 0) {
      toast.error("At least one Job Type is required");
      return;
    }
    if (!formData.job_created_date) {
      toast.error("Date is required");
      return;
    }

   if (isFFDivision() && !plantCode?.value) {
      toast.error("Plant Code is required");
      return;
    }

    if (!formData.supply_period) {
      toast.error("Supply Period is required");
      return;
    }

    if (actionType === "submit") {
      setPendingAction("submit");
      setOpenConfirm(true);
      return;
    }
    await performSubmit(actionType);
  };


  const performSubmit = async (actionType) => {
    if (actionType === "submit") {
      setIsSubmitting(true);
    } else {
      setIsSaving(true);
    }
    try {
      const submitData = {
        actions: [actionType],
        jobs: allCategories.map((category, categoryIndex) => {
          // Calculate totals
          const total_sales_accrual = category.salesRows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0);
          const total_cost_accrual = category.costRows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0);

          // Prepare sales lines
          const sales = category.salesRows
            .filter(row => row.description || row.SalesunitQuantity || row.salesRate || row.salesUploadedFiles?.length)
            .map((row, lineindex) => {
              const salesKey = row.salesUploadedFiles?.length ? `sales_${categoryIndex}_${lineindex}` : null;
              return {
                charge_id: selectedSalesChargeIds[`${categoryIndex}_${lineindex}`] || 0,
                description_of_charges: row.description || "",
                po_wo_number: row.po_wo_number || null,
                po_wo_date: row.po_wo_date || null,
                contract_value: parseFloat(row.salesContractValue) || 0,
                accrual: row.salesNetTotal || "0",
                remarks: row.salesRemarks || "",
                unit_of_quantity: parseFloat(row.SalesunitQuantity) || 0,
                unit_of_rate: parseFloat(row.salesRate) || 0,
                net_total: parseFloat(row.salesNetTotal) || 0,
                attachment_key: salesKey
              };
            });

          // Prepare cost lines
          const cost = category.costRows
            .filter(row => row.description || row.CostunitQuantity || row.costRate || row.costUploadedFiles?.length)
            .map((row, lineindex) => {
              const costKey = row.costUploadedFiles?.length ? `cost_${categoryIndex}_${lineindex}` : null;
              return {
                charge_id: selectedCostChargeIds[`${categoryIndex}_${lineindex}`] || 0,
                description_of_charges: row.description || "",
                po_wo_number: row.po_wo_number || null,
                po_wo_date: row.po_wo_date || null,
                contract_value: parseFloat(row.costContractValue) || 0,
                accrual: row.costNetTotal || "0",
                remarks: row.costRemarks || "",
                vendor_id: selectedVendorIds[`${categoryIndex}_${lineindex}`] || 0,
                unit_of_quantity: parseFloat(row.CostunitQuantity) || 0,
                unit_of_rate: parseFloat(row.costRate) || 0,
                net_total: parseFloat(row.costNetTotal) || 0,
                attachment_key: costKey,
                vendor_inv_number: row.vendor_inv_number || "",
                vendor_inv_date: row.vendor_inv_date || null,
              };
            });

          return {
            project_id: parseInt(formData.project_id) || 0,
            job_type_id: parseInt(category.id) || 0,
            job_created_date: formData.job_created_date || "",
            ff_plant_id: hasFFJobType() ? plantCode?.value || null : null,
            supply_period: formatSupplyPeriod(formData.supply_period),
            total_sales_accrual: parseFloat(total_sales_accrual.toFixed(2)),
            total_cost_accrual: parseFloat(total_cost_accrual.toFixed(2)),
            job_line: {
              sales,
              cost
            }
          };
        }).filter(job => job.job_line.sales.length > 0 || job.job_line.cost.length > 0) // Keep only jobs with lines
      };

      const formDataPayload = new FormData();
      formDataPayload.append('data', JSON.stringify(submitData));

      // Append files
      allCategories.forEach((category, categoryIndex) => {
        category.salesRows.forEach((row, lineindex) => {
          const salesKey = `sales_${categoryIndex}_${lineindex}`;
          if (row.salesUploadedFiles?.length) {
            row.salesUploadedFiles.forEach(file => {
              formDataPayload.append(`attachments[${salesKey}][]`, file);
            });
          }
        });
        category.costRows.forEach((row, lineindex) => {
          const costKey = `cost_${categoryIndex}_${lineindex}`;
          if (row.costUploadedFiles?.length) {
            row.costUploadedFiles.forEach(file => {
              formDataPayload.append(`attachments[${costKey}][]`, file);
            });
          }
        });
      });

      console.log("Submitting body:", JSON.stringify(submitData, null, 2));

      const response = await axiosInstance.post('/job/save', formDataPayload, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      console.log('Success:', response.data);
      toast.success(`Job ${actionType === "save" ? "saved" : "submitted"} successfully!`);
      setTimeout(() => navigate("/jobs"), 1500);

    } catch (error) {
      console.error('Error:', error);
      const errorMessage = error.response?.data?.message || `Failed to ${actionType} job`;
      toast.error(errorMessage);
    }
    finally {
      setIsSaving(false);
      setIsSubmitting(false);
    }
  };

  const handleSave = () => handleSubmit("save")

  const handleUpdate = async (actionType = "submit") => {
    if (isSaving || isSubmitting) return;
    if (!validateCategories()) return;

    if (hasFFJobType() && !plantCode?.value) {
      toast.error("Plant Code is required");
      return;
    }

    if (actionType === "submit") {
      setPendingUpdateAction("submit");
      setOpenConfirmUpdate(true);
      return;
    }
    await performUpdate(actionType);
  };

  const performUpdate = async (actionType) => {
    if (actionType === "submit") {
      setIsSubmitting(true);
    } else {
      setIsSaving(true);
    }
    try {
      console.log("action type:", actionType);

      const updateData = {
        actions: [actionType],
        jobs: allCategories.map((category, categoryIndex) => ({
          id: jobid,
          jobnumber: formData.job_no || 0,
          project_id: parseInt(formData.project_id) || 0,
          job_type_id: parseInt(category.id) || 0,
          job_created_date: formData.job_created_date || "",
          ff_plant_id: hasFFJobType() ? plantCode?.value || null : null,
          supply_period: formatSupplyPeriod(formData.supply_period),
          deleted_sales_line_ids: deletedSalesLineIds,
          deleted_cost_line_ids: deletedCostLineIds, 
          total_sales_accrual: parseFloat(
            category.salesRows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0).toFixed(2)
          ),
          total_cost_accrual: parseFloat(
            category.costRows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0).toFixed(2)
          ),
          job_line: {
            sales: category.salesRows
              .filter(row =>
                row.description || row.SalesunitQuantity || row.salesRate ||
                row.salesUploadedFiles?.length || row.attachment_urls?.sales
              )
              .map((row, rowIndex) => {
                const salesKey = row.salesUploadedFiles?.length ? `sales_${categoryIndex}_${rowIndex}` : null;
                return {
                  job_line_id: row.job_sales_line_id || null,
                  project_id: parseInt(formData.project_id) || 0,
                  job_type_id: parseInt(category.id) || 0,
                  charge_id: selectedSalesChargeIds[`${categoryIndex}_${rowIndex}`] || 0,
                  description_of_charges: row.description || "",
                  po_wo_number: row.po_wo_number || null,
                  po_wo_date: row.po_wo_date || null,
                  unit_of_quantity: parseFloat(row.SalesunitQuantity) || 0,
                  unit_of_rate: parseFloat(row.salesRate) || 0,
                  accrual: row.salesNetTotal || "0",
                  remarks: row.salesRemarks || "",
                  net_total: parseFloat(row.salesNetTotal) || 0,
                  contract_value: parseFloat(row.salesContractValue) || 0,
                  attachment_keys: {
                    sales: salesKey
                  },
                  existing_sales_attachment_url: row.attachment_urls?.sales || null
                };
              }),
            cost: category.costRows
              .filter(row =>
                row.description || row.CostunitQuantity || row.costRate ||
                row.costUploadedFiles?.length || row.attachment_urls?.cost
              )
              .map((row, rowIndex) => {
                const costKey = row.costUploadedFiles?.length ? `cost_${categoryIndex}_${rowIndex}` : null;
                return {
                  job_line_id: row.job_cost_line_id || null,
                  project_id: parseInt(formData.project_id) || 0,
                  job_type_id: parseInt(category.id) || 0,
                  charge_id: selectedCostChargeIds[`${categoryIndex}_${rowIndex}`] || 0,
                  description_of_charges: row.description || "",
                  po_wo_number: row.po_wo_number || null,
                  po_wo_date: row.po_wo_date || null,
                  unit_of_quantity: parseFloat(row.CostunitQuantity) || 0,
                  unit_of_rate: parseFloat(row.costRate) || 0,
                  accrual: row.costNetTotal || "0",
                  remarks: row.costRemarks || "",
                  net_total: parseFloat(row.costNetTotal) || 0,
                  contract_value: parseFloat(row.costContractValue) || 0,
                  vendor_id: selectedVendorIds[`${categoryIndex}_${rowIndex}`] || 0,
                  vendor_inv_number: row.vendor_inv_number || "",
                  vendor_inv_date: row.vendor_inv_date || null,
                  attachment_keys: {
                    cost: costKey
                  },
                  existing_cost_attachment_url: row.attachment_urls?.cost || null
                };
              })
          }
        })).filter(job => job.job_line.sales.length > 0 || job.job_line.cost.length > 0)
      };

      const formDataPayload = new FormData();
      formDataPayload.append("data", JSON.stringify(updateData));

      // Append files
      allCategories.forEach((category, categoryIndex) => {
        category.salesRows.forEach((row, rowIndex) => {
          const salesKey = `sales_${categoryIndex}_${rowIndex}`;
          if (row.salesUploadedFiles?.length) {
            row.salesUploadedFiles.forEach(file => {
              formDataPayload.append(`attachments[${salesKey}][]`, file);
            });
          }
        });
        category.costRows.forEach((row, rowIndex) => {
          const costKey = `cost_${categoryIndex}_${rowIndex}`;
          if (row.costUploadedFiles?.length) {
            row.costUploadedFiles.forEach(file => {
              formDataPayload.append(`attachments[${costKey}][]`, file);
            });
          }
        });
      });

      console.log("Update Payload:", JSON.stringify(updateData, null, 2));

      const response = await axiosInstance.post("/job/update", formDataPayload, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });

      toast.success(`Job ${actionType === "save" ? "saved" : "submitted"} successfully!`);
      setTimeout(() => navigate("/jobs"), 1500);
    } catch (error) {
      console.error("Update error:", error);
      const errorMessage = error.response?.data?.message || `Failed to ${actionType} job`;
      toast.error(errorMessage);
    } finally {
      setIsSaving(false);
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        // const response = await axios.get("https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/costsolution/projects/autosuggestion");
        const response = await axiosInstance.get("/costsolution/projects/autosuggestion");
        if (response.data) {
          setProjectOptions(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch projects:", error);
      }
    };

    fetchProjects();
  }, []);


  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axiosInstance.get(`/project_based/getJobTypes/${projectId}`);

        console.log(response.data.jobtypes)
        if (response.data && Array.isArray(response.data.jobtypes)) {
          console.log("jobtypecalled");
          console.log(response.data)
          setJobOptions(response.data.jobtypes);
          setJobTypesWithDivision(response.data.jobtypes);
        }
      } catch (error) {
        console.error("Failed to fetch job options:", error);
      }
    };

    fetchJobs();
  }, [projectId]);

  const handleProjectSelect = (project) => {
    setFormData({
      ...formData,
      project_id: project.value,
      project_name: project.label,
    });
    setShowProjectSuggestions(false);
  };

  useEffect(() => {
    setAllCategories(prevCategories => {
      const updatedCategories = [...prevCategories];

      selectedJobs.forEach((jobValue) => {
        const alreadyExists = updatedCategories.some(cat => cat.id === jobValue);
        if (!alreadyExists) {
          let jobObject = {};

          if (data && !hasProjectChanged) {
            // Process sales and cost lines separately
            const salesRows = data.sales_lines
              ? data.sales_lines.filter(line => line.job_type_id === jobValue).map(line => ({
                billingtype: "",
                elements: "",
                remarks: "",
                job_sales_line_id: line.id,
                charge_id: line.charge_id || 0,
                contract_charge_line_table_id: line.id || null,
                description: line.description_of_charges || "",
                SalesunitQuantity: parseFloat(line.unit_of_quantity) || 0,
                salesRemarks: line.remarks || "",
                salesRate: parseFloat(line.unit_of_rate) || 0,
                salesNetTotal: parseFloat(line.net_total) || 0,
                salesContractValue: parseFloat(line.contract_value) || 0,
                chargecode: line.charge_code || "",
                uploadedFiles: [],
                isChecked: false,
                attachment_urls: { sales: line.attachment_url || null },
                salesAttachment: line.attachment_url || "",
                po_wo_number: line.po_wo_number || null,
                po_wo_date: line.po_wo_date || null
              }))
              : [];

            const costRows = data.cost_lines
              ? data.cost_lines.filter(line => line.job_type_id === jobValue).map(line => ({
                billingtype: "",
                elements: "",
                remarks: "",
                job_cost_line_id: line.id,
                charge_id: line.charge_id || 0,
                contract_charge_line_table_id: line.id || null,
                description: line.description_of_charges || "",
                CostunitQuantity: parseFloat(line.unit_of_quantity) || 0,
                costRemarks: line.remarks || "",
                costRate: parseFloat(line.unit_of_rate) || 0,
                costNetTotal: parseFloat(line.net_total) || 0,
                costContractValue: parseFloat(line.contract_value) || 0,
                chargecode: line.charge_code || "",
                uploadedFiles: [],
                isChecked: false,
                attachment_urls: { cost: line.attachment_url || null },
                costAttachment: line.attachment_url || "",
                vendor_name: line.vendor_name || "",
                vendor_id: line.vendor_id || 0,
                vendor_inv_number: line.vendor_inv_number || "",
                vendor_inv_date: line.vendor_inv_date || null,
                po_wo_number: line.po_wo_number || null,
                po_wo_date: line.po_wo_date || null
              }))
              : [];

            if (salesRows.length > 0 || costRows.length > 0) {
              const initialTotals = {
                salesNetTotal: salesRows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0),
                costNetTotal: costRows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0),
                profitAmount: salesRows.reduce((sum, row) => sum + (parseFloat(row.salesNetTotal) || 0), 0) -
                  costRows.reduce((sum, row) => sum + (parseFloat(row.costNetTotal) || 0), 0)
              };

              const initialProfitPercent = initialTotals.costNetTotal > 0
                ? ((initialTotals.profitAmount / initialTotals.costNetTotal) * 100).toFixed(2)
                : '0.00';

              jobObject = {
                id: jobValue,
                name: data.job_type_name || `Category ${jobValue}`,
                salesRows,
                costRows,
                salesNetTotal: initialTotals.salesNetTotal.toFixed(2),
                costNetTotal: initialTotals.costNetTotal.toFixed(2),
                profitAmount: initialTotals.profitAmount.toFixed(2),
                profitPercent: initialProfitPercent
              };
            }
          }

          if (!jobObject.id) {
            // Fallback if no lines found or create mode
            jobObject = {
              id: jobValue,
              name: `Category ${jobValue}`,
              salesRows: [{
                billingtype: "",
                elements: "",
                remarks: "",
                charge_id: 0,
                contract_charge_line_table_id: null,
                description: '',
                SalesunitQuantity: '',
                salesRemarks: '',
                salesRate: '',
                salesNetTotal: '0.00',
                salesContractValue: '0.00',
                chargecode: '',
                uploadedFiles: [],
                isChecked: false,
                attachment_urls: { sales: null, cost: null },
                salesAttachment: ""
              }],
              costRows: [{
                billingtype: "",
                elements: "",
                remarks: "",
                charge_id: 0,
                contract_charge_line_table_id: null,
                description: '',
                CostunitQuantity: '',
                costRemarks: '',
                costRate: '',
                costNetTotal: '0.00',
                costContractValue: '0.00',
                chargecode: '',
                uploadedFiles: [],
                isChecked: false,
                attachment_urls: { sales: null, cost: null },
                costAttachment: "",
                vendor_name: "",
                vendor_id: 0
              }],
              salesNetTotal: '0.00',
              costNetTotal: '0.00',
              profitAmount: '0.00',
              profitPercent: '0.00'
            };
          }

          updatedCategories.push(jobObject);
        }
      });

      // Filter out removed jobs if selectedJobs has changed
      return updatedCategories.filter(cat => selectedJobs.includes(cat.id));
    });
  }, [selectedJobs, data?.job_id]);



  const fetchProjectSuggestions = async (query, rowIndex) => {
    try {
      setSuggestionsMap([]);
      // const response = await axios.get("https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/costsolution/projects/autosuggestion", { query });
      const response = await axiosInstance.get("/costsolution/projects/autosuggestion", { query });

      // Example structure: { autosuggestion: [ { label: '', value: '' }, ... ] }
      if (response.data?.autosuggestion) {
        const newSuggestions = response.data?.autosuggestion || [];
        setProjectOptions(newSuggestions);
        setShowProjectSuggestions(true);
      }
    } catch (err) {
      console.error("Failed to fetch suggestions", err);
      // setProjectOptions({[]});
      // setShowSuggestionsMap(prev => ({ ...prev, [rowIndex]: false }));
    }
  };

  const fetchSuggestions = async (searchTerm = "", rowIndex, index, projectId) => {
    try {
      setSuggestionsMap([]);

      // const response = await axios.get(
      //   `https://digitallr-uat.flyjaclogistics.com/cost_modelling-be/project_based/getchargecodes/${projectId}`,
      //   {
      //     params: {
      //       term: searchTerm
      //     }
      //   }
      // );

      const response = await axiosInstance.get(
        `/project_based/getchargecodes/${projectId}`,
        {
          params: {
            term: searchTerm
          }
        }
      );

      if (response.data?.chargecodes) {

        const newSuggestions = response.data?.chargecodes || [];
        setSuggestionsMap(prev => {
          const updated = { ...prev };
          if (!updated[index]) updated[index] = {}; // initialize if empty
          updated[index][rowIndex] = newSuggestions;
          console.log("Updated suggestionsMap:", updated);
          return updated;
        });

        setShowSuggestionsMap(prev => ({
          ...prev,
          [`${index}_${rowIndex}`]: true,
        }));
      }
    } catch (err) {
      console.error("Failed to fetch suggestions", err);

      setSuggestionsMap(prev => {
        const updated = { ...prev };
        if (!updated[index]) updated[index] = {};
        updated[index][rowIndex] = []; // clear only that one
        return updated;
      });

      setShowSuggestionsMap(prev => ({
        ...prev,
        [`${index}_${rowIndex}`]: false,
      }));
    }
  };

  const calculateCategoryTotals = (category) => {
    const salesTotals = {
      quantity: 0,
      rate: 0,
      netValue: 0
    };

    const costTotals = {
      quantity: 0,
      rate: 0,
      netValue: 0
    };

    // Calculate sales totals
    category.salesRows.forEach(row => {
      salesTotals.quantity += parseFloat(row.SalesunitQuantity) || 0;
      salesTotals.rate += parseFloat(row.salesRate) || 0;
      salesTotals.netValue += parseFloat(row.salesNetTotal) || 0;
    });

    // Calculate cost totals
    category.costRows.forEach(row => {
      costTotals.quantity += parseFloat(row.CostunitQuantity) || 0;
      costTotals.rate += parseFloat(row.costRate) || 0;
      costTotals.netValue += parseFloat(row.costNetTotal) || 0;
    });

    return {
      salesTotals,
      costTotals
    };
  };


  // const chargesNotEditable = isEdit && contract_id !== null && !canEditCharges;
  const chargesNotEditable = isEdit && contract_id !== null;

  const fetchVendorSuggestions = async (searchTerm = "") => {
    try {
      const response = await axiosInstance.get(
        "/vendor/autosuggestion",
        { params: { term: searchTerm } }
      );
      return response.data?.autosuggestion || [];
    } catch (error) {
      console.error("Failed to fetch vendor suggestions:", error);
      return [];
    }
  };

  // Separate fetch functions
  const fetchSalesSuggestions = async (searchTerm = "", rowIndex, index) => {
    try {
      const response = await axiosInstance.get(
        `/getnonprojectsaleschargecodes`,
        { params: { term: searchTerm } }
      );

      if (response.data?.chargecodes) {
        setSalesSuggestionsMap(prev => {
          const updated = { ...prev };
          if (!updated[index]) updated[index] = {};
          updated[index][rowIndex] = response.data.chargecodes;
          return updated;
        });

        setShowSalesSuggestionsMap(prev => ({
          ...prev,
          [`${index}_${rowIndex}`]: true,
        }));
      }
    } catch (err) {
      console.error("Failed to fetch sales suggestions", err);
      setSalesSuggestionsMap(prev => {
        const updated = { ...prev };
        if (!updated[index]) updated[index] = {};
        updated[index][rowIndex] = [];
        return updated;
      });
    }
  };

  // Similar function for cost suggestions
  const fetchCostSuggestions = async (searchTerm = "", rowIndex, index) => {
    try {
      const response = await axiosInstance.get(
        `/getnonprojectcostchargecodes`,
        { params: { term: searchTerm } }
      );

      if (response.data?.chargecodes) {
        setCostSuggestionsMap(prev => {
          const updated = { ...prev };
          if (!updated[index]) updated[index] = {};
          updated[index][rowIndex] = response.data.chargecodes;
          return updated;
        });

        setShowCostSuggestionsMap(prev => ({
          ...prev,
          [`${index}_${rowIndex}`]: true,
        }));
      }
    } catch (err) {
      console.error("Failed to fetch cost suggestions", err);
      setCostSuggestionsMap(prev => {
        const updated = { ...prev };
        if (!updated[index]) updated[index] = {};
        updated[index][rowIndex] = [];
        return updated;
      });
    }
  };

  const handleViewModeChange = (categoryId, mode) => {
    setViewModes(prev => ({
      ...prev,
      [categoryId]: mode
    }));
  };

  const getViewModeForCategory = (categoryId) => {
    return viewModes[categoryId] || "split";
  };

  const openRemarkPopup = (type, rowIndex, lineIndex, value) => {
    setRemarkMeta({ type, rowIndex, lineIndex });
    setRemarkValue(value || "");
    setShowRemarkPopup(true);
  };

  const handleSaveRemark = (updatedValue) => {
    if (!remarkMeta) return;

    const { type, rowIndex, lineIndex } = remarkMeta;

    if (type === "sales") {
      handleSalesInputChange(
        { target: { value: updatedValue } },
        rowIndex,
        lineIndex,
        "salesRemarks"
      );
    } else {
      handleCostInputChange(
        { target: { value: updatedValue } },
        rowIndex,
        lineIndex,
        "costRemarks"
      );
    }

    setShowRemarkPopup(false);
  };

  const validateCategories = () => {
    for (let categoryIndex = 0; categoryIndex < allCategories.length; categoryIndex++) {
      const category = allCategories[categoryIndex];

      for (let rowIndex = 0; rowIndex < category.salesRows.length; rowIndex++) {
        const row = category.salesRows[rowIndex];

        const typedChargeCode =
          salesInputValues?.[categoryIndex]?.[rowIndex]?.trim();

        const chargeId =
          selectedSalesChargeIds[`${categoryIndex}_${rowIndex}`] ?? 0;

        const isRowUsed =
          typedChargeCode ||
          row.description ||
          row.SalesunitQuantity ||
          row.salesRate ||
          row.salesUploadedFiles?.length;

        if (isRowUsed) {
          if (!typedChargeCode) {
            toast.error(
              `Sales Charge Code is required - LineItem ${rowIndex + 1}.`
            );
            return false;
          }

          if (chargeId === 0) {
            toast.error(
              `Please select a valid Sales Charge Code from the list - LineItem ${rowIndex + 1}.`
            );
            return false;
          }

          if (!row.description?.trim()) {
            toast.error(
              `Sales Description is required - LineItem ${rowIndex + 1}.`
            );
            return false;
          }
        }
      }

      for (let rowIndex = 0; rowIndex < category.costRows.length; rowIndex++) {
        const row = category.costRows[rowIndex];

        const typedChargeCode =
          costInputValues?.[categoryIndex]?.[rowIndex]?.trim();

        const chargeId =
          selectedCostChargeIds[`${categoryIndex}_${rowIndex}`] ?? 0;

        const isRowUsed =
          typedChargeCode ||
          row.description ||
          row.CostunitQuantity ||
          row.costRate ||
          row.costUploadedFiles?.length ||
          row.vendorUploadedFiles?.length;

        if (isRowUsed) {
          if (!typedChargeCode) {
            toast.error(
              `Cost Charge Code is required - LineItem ${rowIndex + 1}.`
            );
            return false;
          }

          if (chargeId === 0) {
            toast.error(
              `Please select a valid Cost Charge Code from the list - LineItem ${rowIndex + 1}.`
            );
            return false;
          }

          if (!row.description?.trim()) {
            toast.error(
              `Cost Description is required - LineItem ${rowIndex + 1}.`
            );
            return false;
          }
        }
      }
    }
    return true;
  };

  const hasFFJobType = () => {
    if (selectedJobs.length === 0 || jobTypesWithDivision.length === 0) return false;

    const selectedJobValue = selectedJobs[0];
    const selectedJob = jobTypesWithDivision.find(job => job.value === selectedJobValue);

    return selectedJob?.division_type?.toUpperCase() === 'FF';
  };

  const isFFDivision = () => {
    if (isEdit) {
      return data?.division_type?.toLowerCase() === "ff";
    }
    return hasFFJobType();
  };

  const loadPlantCodeOptions = async (inputValue) => {

    const selectedJob = jobTypesWithDivision.find(
      job => job.value === selectedJobs[0]
    );

    if (!selectedJob) return [];

    try {

      const res = await axiosInstance.get("/plant_code/autosuggestion", {
        params: {
          term: inputValue || "",
          division_type: selectedJob.division_type
        }
      });

      return res.data.autosuggestion.map(item => ({
        label: item.label,
        value: item.value
      }));

    } catch (error) {
      console.error("Plant code autosuggest error", error);
      return [];
    }

  };

  useEffect(() => {
    const setProjectPlantCode = async () => {

      if (!selectedJobs.length) return;

      const selectedJob = jobTypesWithDivision.find(
        job => job.value === selectedJobs[0]
      );

      if (!selectedJob) return;

      try {

        const res = await axiosInstance.get("/plant_code/autosuggestion", {
          params: {
            term: "",
            division_type: selectedJob.division_type
          }
        });

        const options = res.data?.autosuggestion?.map(item => ({
          label: item.label,
          value: item.value
        })) || [];

        // ⭐ important
        setPlantCodeOptions(options);

        if (projectPlantId) {
          const match = options.find(opt => opt.value === projectPlantId);

          if (match) {
            setPlantCode(match);
          }
        }

      } catch (error) {
        console.error("Plant code auto load error", error);
      }

    };

    setProjectPlantCode();

  }, [selectedJobs, projectPlantId]);

  const formatSupplyPeriod = (date) => {
    if (!date) return null;

    const options = { month: "short", year: "numeric" };
    return new Date(date).toLocaleDateString("en-US", options).replace(" ", "-");
  };

  return (
    <>
      <Jobs_header onSearch={null} disableSearch={true} />
      <div className='jobs_creation'>
        <div className="jobs_popup_header">
          <div className="jobs_popup_header_left">
            <img src={back_arrow} alt="Back Arrow" onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }} />
            <p className="new_job">New job</p>
          </div>
          <div className="jobs_popup_header_right">
            <button className="cancel_btn" onClick={() => navigate(-1)}>Cancel</button>
            {isEdit ? (
              <>
                <button className="save_btn" onClick={() => handleUpdate("save")} disabled={isSaving || isSubmitting}>{isSaving ? "Saving..." : "Save"}</button>
                <button className="submit_btn" onClick={() => handleUpdate("submit")} disabled={isSaving || isSubmitting}>{isSubmitting ? "Submitting..." : "Submit"}</button>
              </>
            ) : (
              <>
                <button className="save_btn" onClick={() => handleSubmit("save")} disabled={isSaving || isSubmitting}>{isSaving ? "Saving..." : "Save"}</button>
                <button className="submit_btn" onClick={() => handleSubmit("submit")} disabled={isSaving || isSubmitting}>{isSubmitting ? "Submitting..." : "Submit"}</button>
              </>
            )}
          </div>

        </div>

        <div className='jobs_popup_project jobs-datepicker-scope'  style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          padding: '15px',
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          marginTop: '15px',
        }}>
          <div className='jobs_popup_content' style={{
            display: 'grid',
            gridTemplateColumns: isFFDivision()
              ? 'repeat(4, 1fr)'
              : 'repeat(3, 1fr)',
            gap: '20px',
            padding: '0',
            alignItems: 'end',
            fontFamily: 'Work Sans'
          }}>
            {/* Project Input with Autocomplete */}
            <div className="jobs-filter-field">
              <p className="jobs-filter-text">Project <span style={{ color: 'red' }}>*</span></p>
              <AsyncSelect
                cacheOptions
                defaultOptions
                loadOptions={loadProjectOptions}
                // onChange={(selectedOption) => {
                //   if (selectedOption) {
                //     setProjectInput(selectedOption.label);
                //     setFormData({
                //       ...formData,
                //       project_id: selectedOption.value,
                //       project_name: selectedOption.label
                //     });
                //     setselectedproject(selectedOption.value);
                //     setselectedprojectId(selectedOption.value);
                //   } else {
                //     // Handle clear action
                //     setProjectInput('');
                //     setFormData({
                //       ...formData,
                //       project_id: '',
                //       project_name: ''
                //     });
                //     setselectedproject('');
                //     setselectedprojectId('');
                //   }
                // }}
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setHasProjectChanged(true);

                    setProjectInput(selectedOption.label);
                    setFormData({
                      ...formData,
                      project_id: selectedOption.value,
                      project_name: selectedOption.label
                    });
                    setselectedproject(selectedOption.value);
                    setselectedprojectId(selectedOption.value);
                    setProjectPlantId(selectedOption.plant_id);
                    setPlantCode(null);
                    // 🔄 Clear all job-dependent data
                    setSelectedJobs([]);
                    setAllCategories([]);
                    setInputValues({});
                    setSelectedChargeIds({});
                  } else {
                    setProjectInput('');
                    setFormData({ ...formData, project_id: '', project_name: '' });
                    setselectedproject('');
                    setselectedprojectId('');
                    setProjectPlantId(null);
                    setPlantCode(null);
                    setSelectedJobs([]);
                    setAllCategories([]);
                    setInputValues({});
                    setSelectedChargeIds({});
                  }
                }}
                value={projectInput ? {
                  label: projectInput,
                  value: formData.project_id
                } : null}
                placeholder="Search project..."
                isClearable
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: '44px',
                    borderRadius: '12px',
                    fontSize: '14px',
                    width: '100%',
                    borderColor: state.isFocused ? '#454CF2' : '#DCDFE4',
                    boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                    '&:hover': {
                      borderColor: '#454CF2'
                    },
                  }),
                  container: (base) => ({
                    ...base,
                    width: '100%'
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 999,
                    fontSize: '13px',
                    marginTop: '4px',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                  }),
                  option: (base, { isFocused }) => ({
                    ...base,
                    backgroundColor: isFocused ? '#f2f2f2' : '#fff',
                    color: '#333',
                    padding: '10px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #eee',
                    '&:active': {
                      backgroundColor: '#f2f2f2'
                    }
                  }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    padding: '8px'
                  }),
                  clearIndicator: (base) => ({
                    ...base,
                    padding: '8px'
                  })
                }}
              />
            </div>
            <div className="jobs-filter-field" ref={dropdownRef}>
              <p className="jobs-filter-text">Job type <span style={{ color: 'red' }}>*</span></p>
              <div className="custom-multiselect">
                <div
                  className="jobs-type-filter-dropdown"
                  onClick={toggleJobDropdown}
                >
                  {selectedJobs.length > 0
                    ? jobOptions.find(j => j.value === selectedJobs[0])?.label || "Select Jobs"
                    : "Select Jobs"}
                  <span className="dropdown-arrow">▼</span>
                </div>

                {isJobDropdownOpen && (
                  <div className="multiselect-options">
                    {jobOptions.map(job => {
                      const isSelected = selectedJobs.includes(Number(job.value));
                      const isDisabled = selectedJobs.length > 0 && !isSelected;

                      return (
                        <label key={job.id} className={`multiselect-option ${isDisabled ? 'disabled' : ''}`}>
                          <input
                            type="checkbox"
                            checked={isSelected}
                            // disabled={isDisabled}
                            disabled={isEdit || isDisabled}
                            onChange={() => handleJobCheckboxChange(Number(job.value))}
                          />
                          {job.label}
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
            </div>

            <div className="jobs-filter-field" style={{ display: 'grid' }}>
              <p className="jobs-filter-text">Date <span style={{ color: 'red' }}>*</span></p>
              <div style={{ display: 'flex', gap: '15px' }}>
                <input className="jobs-filter-date" type='date' alt='' value={formData.job_created_date}
                  onChange={handleDateChange} />
                <button className='jobs-filter-upload-btn' onClick={() => setIsUploadPopupOpen(true)} style={{ display: 'none' }}>
                  Upload
                </button>
                {isUploadPopupOpen && (
                  <div className="upload-popup-overlay" onClick={() => setIsUploadPopupOpen(false)}>
                    <div className="upload-popup" onClick={(e) => e.stopPropagation()}>
                      <div className="upload-popup-header">
                        <h3>Upload</h3>
                        <button className="close-popup-btn" onClick={() => setIsUploadPopupOpen(false)}>
                          ×
                        </button>
                      </div>

                      <div className="upload-popup-chargecode-file">
                        <p className="upload-popup-label">Select Charge Code to attach file</p>
                        <select className="upload-popup-dropdown">
                          <option value="">Select</option>
                          <option value="Project1">Project 1</option>
                          <option value="Project2">Project 2</option>
                          <option value="Project3">Project 3</option>
                        </select>
                      </div>

                      <div className="upload-popup-content">
                        <label className="file-upload-label">Upload Your file here
                          <input
                            type="file"
                            multiple
                            onChange={handleAttachFileUpload}
                            style={{ display: "none" }}
                          />
                          <div className="upload-area">
                            {uploadedFiles.length === 0 ? (
                              <div className="upload-empty-state">
                                <img src={plus_circle} alt="Upload" className="upload-icon-circle" />
                                <p className="upload-instruction">Drag or drop your file here</p>
                                <p className="file-types">File supported: XLS, PDF</p>
                                <button className="browse-file-btn" >Browse file</button>
                              </div>
                            ) : (
                              <div className="uploaded-files-container">
                                {uploadedFiles.map((file, index) => {
                                  const fileType = file.name.split('.').pop().toUpperCase();
                                  return (
                                    <div key={index} className="uploaded-file-display">
                                      <div className="file-icon-container">
                                        <img src={excel_icon} alt="File icon" className="file-type-icon" />
                                        <span className="file-type-badge">{fileType}</span>
                                      </div>
                                      <div className="file-info">
                                        <span className="file-name">{file.name}</span>
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleAttachRemoveFile(index);
                                          }}
                                          className="remove-file-btn"
                                        >
                                          <img src={delete_icon} alt="Delete" />
                                        </button>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            )}
                          </div>
                        </label>

                        <div className="upload-popup-actions">
                          <button
                            className="upload-submit-btn"
                            onClick={() => {
                              console.log("Uploading files:", uploadedFiles);
                              setIsUploadPopupOpen(false);
                            }}
                            disabled={uploadedFiles.length === 0}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {isFFDivision() && (
              <div className="jobs-filter-field">
                <p className="jobs-filter-text">Plant Code <span style={{ color: 'red' }}>*</span></p>
                <AsyncSelect
                  value={plantCode}
                  cacheOptions
                  defaultOptions={plantCodeOptions}
                  loadOptions={loadPlantCodeOptions}
                  onChange={(selectedOption) => {
                    setPlantCode(selectedOption);
                  }}
                  placeholder="Search Plant Code..."
                  isClearable
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "40px",
                      borderRadius: "12px",
                      fontSize: "13px",
                      width: "100%",
                      borderColor: state.isFocused ? "#454CF2" : "#D0D6DF",
                      boxShadow: state.isFocused ? "0 0 0 1px #454CF2" : "none",
                      "&:hover": { borderColor: "#454CF2" },
                    }),
                    container: (base) => ({ ...base, width: "100%" }),
                    menu: (base) => ({ ...base, fontSize: "12px" }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "250px",
                      overflowY: "auto"
                    }),
                  }}
                />
              </div>
            )}

            <div className="jobs-filter-field" >
              <p className="jobs-filter-text">Supply Period <span style={{ color: 'red' }}>*</span></p>

              <DatePicker
                selected={formData.supply_period}
                onChange={(date) =>
                  setFormData({ ...formData, supply_period: date })
                }
                dateFormat="MMM-yyyy"
                showMonthYearPicker
                placeholderText="MMM-YYYY"
                disabled={isEdit}
              />
            </div>

            <div className='jobs_popup_jobs_cards'>
              <p className="jobs-filter-cards-text">Jobs Cards:</p>
              <div className="job_card_list">
                {selectedJobs.map((jobId, index) => {
                  const job = jobOptions.find(j => j.value === jobId);
                  return (
                    <div key={index} className="job_card_item">
                      <span>{job ? job.label : jobId}</span>
                      <button className="job_card_remove" disabled={isEdit} onClick={() => handleRemoveJob(jobId)}>×</button>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div className="invoice_popup_categories">
          {allCategories.map((category, index) => {
            const totals = calculateCategoryTotals(category);
            const jobType = jobOptions.find(job => job.value === category.id);
            console.log("category salesNetTotal.....", category);
            console.log("category rowsssssss.....", category.rows);
            console.log("category row.....", category.row);
            console.log("category salesNetTotal.....", category.salesNetTotal)
            return (
              <div key={category.id} className="invoice_popup_outercategory">
                <div className="invoice_popup_category_header">
                  <div className="category_name_left">
                    <span className="category_name">
                      Job Type -  {jobType ? jobType.label : category.name}
                    </span>
                  </div>
                  <div style={{
                    display: "flex",
                    gap: "12px",
                    fontSize: '12px',
                    flexWrap: "wrap"
                  }}>
                    {/* SALES BOX */}
                    <div style={{
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      width: 'auto',
                      height: '30px',
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                    }}>
                      <span style={{ color: "green", fontWeight: "600" }}>SALES :</span>
                      <span style={{ color: "#000" }}>Net total : ₹ {category.salesNetTotal?.toLocaleString()}</span>
                    </div>

                    <div style={{
                      width: "1px",
                      backgroundColor: "#ccc",
                      alignSelf: "stretch"
                    }} />

                    {/* COST BOX */}
                    <div style={{
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      width: 'auto',
                      height: '30px',
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                    }}>
                      <span style={{ color: "#007bff", fontWeight: "600" }}>COST :</span>
                      <span style={{ color: "#000" }}>Net total : ₹ {category.costNetTotal?.toLocaleString()}</span>
                    </div>

                    <div style={{
                      width: "1px",
                      backgroundColor: "#ccc",
                      alignSelf: "stretch"
                    }} />

                    <div style={{
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      width: 'auto',
                      height: '30px',
                      boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                    }}>
                      <span style={{ color: "purple", fontWeight: "600" }}>PROFIT :</span>
                      <span style={{ color: "#000" }}>Amount : ₹{category.profitAmount?.toLocaleString()}</span>
                      <span style={{ color: "purple", fontWeight: "600" }}>PROFIT % :</span>
                      <span style={{ color: "#000" }}>{category.profitPercent?.toLocaleString()}%</span>
                    </div>
                  </div>
                </div>

                <div className="invoice_popup_category_subheader">
                  <div className="invoice_popup_element_list" style={{ overflowX: "auto" }}>
                    <div style={{
                      display: "flex",
                      gap: "12px",
                      fontSize: '12px',
                      flexWrap: "wrap",
                      flexGrow: 1,
                      justifyContent: "flex-start",
                      minWidth: "min-content",
                      padding: '10px',
                      cursor: 'pointer',
                      fontWeight: '600'
                    }}>
                      <div onClick={() => handleViewModeChange(category.id, "split")} style={{
                        backgroundColor: getViewModeForCategory(category.id) === "split" ? "#D0E6FF" : "#EDF3F9",
                        borderRadius: "10px",
                        padding: "12px 16px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        height: '30px',
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                        flexShrink: 0,
                        color: getViewModeForCategory(category.id) === "split" ? "#007bff" : "",
                        transition: "all 0.3s ease",
                      }}>
                        <img src={getViewModeForCategory(category.id) === "split" ? split_hover : split} alt="Split View" />
                        <span style={{ transition: "color 0.3s ease" }}>Split View</span>
                      </div>
                      <div style={{
                        width: "1px",
                        backgroundColor: "#ccc",
                        alignSelf: "stretch",
                        flexShrink: 0
                      }} />
                      <div onClick={() => handleViewModeChange(category.id, "sales")} style={{
                        backgroundColor: getViewModeForCategory(category.id) === "sales" ? "#D0E6FF" : "#EDF3F9",
                        borderRadius: "10px",
                        padding: "12px 16px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        height: '30px',
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                        flexShrink: 0,
                        color: getViewModeForCategory(category.id) === "sales" ? "#007bff" : "",
                        transition: "all 0.3s ease",
                      }}>
                        <img src={getViewModeForCategory(category.id) === "sales" ? cost_hover : cost} alt="Sales View" />
                        <span style={{ transition: "color 0.3s ease" }}>Sales View</span>
                      </div>
                      <div style={{
                        width: "1px",
                        backgroundColor: "#ccc",
                        alignSelf: "stretch",
                        flexShrink: 0
                      }} />
                      <div onClick={() => handleViewModeChange(category.id, "cost")} style={{
                        backgroundColor: getViewModeForCategory(category.id) === "cost" ? "#D0E6FF" : "#EDF3F9",
                        borderRadius: "10px",
                        padding: "12px 16px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        height: '30px',
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                        flexShrink: 0,
                        color: getViewModeForCategory(category.id) === "cost" ? "#007bff" : "",
                        transition: "all 0.3s ease",
                      }}>
                        <img src={getViewModeForCategory(category.id) === "cost" ? sales_hover : sales} alt="Sales View" />
                        <span style={{ transition: "color 0.3s ease" }}>Cost View</span>
                      </div>
                    </div>
                    <div className="tables-wrapper">
                      {(getViewModeForCategory(category.id) === "split" || getViewModeForCategory(category.id) === "sales") && (
                        <div className="table-containers sales-table" ref={salesRef} style={{
                          position: 'relative', overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth', flex: getViewModeForCategory(category.id) === "split" ? "0 0 50%" : "1 1 100%",
                          width: getViewModeForCategory(category.id) === "split" ? "50%" : "100%", transition: 'flex 0.2s ease',
                          display: getViewModeForCategory(category.id) === "split" ? "block" :
                            (getViewModeForCategory(category.id) === "sales" ? "block" : "none")
                        }}>
                          <table className="invoice_table">
                            <thead>
                              <tr>
                                <th colSpan="10" style={{ backgroundColor: '#D9FFE2', padding: '10px', color: '#008B1F' }}>SALES</th>
                              </tr>
                              <tr>
                                <th style={{ backgroundColor: '#D9FFE2' }}>CHARGE CODE</th>
                                <th style={{ backgroundColor: '#D9FFE2' }}>DESCRIPTION</th>
                                <th style={{ backgroundColor: '#D9FFE2' }}>PO/WO NO</th>
                                <th style={{ backgroundColor: '#D9FFE2' }}>PO/WO Date</th>
                                <th style={{ backgroundColor: '#D9FFE2', padding: '10px' }}>REMARKS</th>
                                <th style={{ backgroundColor: '#D9FFE2' }}>CONTRACT VALUE</th>
                                <th style={{ backgroundColor: '#D9FFE2' }}>QUANTITY</th>
                                <th style={{ backgroundColor: '#D9FFE2' }}>RATE</th>
                                <th style={{ backgroundColor: '#D9FFE2' }}>NET TOTAL</th>
                                <th style={{ backgroundColor: '#D9FFE2' }}>ATTACHMENT</th>
                              </tr>
                            </thead>
                            <tbody>
                              {category.salesRows.map((row, lineindex) => (
                                <tr key={lineindex}>
                                  <td style={{ position: "relative" }}>
                                    <div className="table-tooltip-container">
                                      <input
                                        type="text"
                                        style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                        // value={inputValues[index]?.[lineindex] || ""}
                                        value={salesInputValues[index]?.[lineindex]?.split("-")[0]?.trim() || ""}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          handleCostInputChange(e, index, lineindex, "chargecode");
                                          setSalesInputValues((prev) => ({
                                            ...prev,
                                            [index]: {
                                              ...prev[index],
                                              [lineindex]: val,
                                            },
                                          }));
                                          fetchSalesSuggestions(val, lineindex, index);
                                        }}
                                        onFocus={() => {
                                          const list = salesSuggestionsMap[index]?.[lineindex] || [];
                                          if (list.length > 0) {
                                            const list = salesSuggestionsMap[index]?.[lineindex] || [];
                                            if (list.length > 0) {
                                              setShowSalesSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: true }));
                                            }
                                          }
                                        }}
                                        onBlur={() => {
                                          setTimeout(() => {
                                            setShowSalesSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));
                                          }, 200);
                                        }}
                                        className="invoice_narrow_input_chargecode"
                                        placeholder="Search"
                                      />
                                      {showSalesSuggestionsMap[`${index}_${lineindex}`] && salesSuggestionsMap[index]?.[lineindex]?.length > 0 && (
                                        <ul
                                          style={{
                                            position: "absolute",
                                            top: "100%",
                                            left: 0,
                                            right: 0,
                                            backgroundColor: "white",
                                            border: "1px solid #ccc",
                                            zIndex: 999,
                                            maxHeight: "150px",
                                            overflowY: "auto",
                                            margin: 0,
                                            padding: 0,
                                            listStyle: "none",
                                          }}
                                        >
                                          {salesSuggestionsMap[index]?.[lineindex].map((item) => (
                                            <li
                                              key={item.value}
                                              onMouseDown={() => {
                                                const selected = item.label;
                                                const chargeId = item.value;

                                                setSalesInputValues((prev) => ({
                                                  ...prev,
                                                  [index]: {
                                                    ...prev[index],
                                                    [lineindex]: selected,
                                                  },
                                                }));

                                                setSelectedSalesChargeIds((prev) => ({
                                                  ...prev,
                                                  [`${index}_${lineindex}`]: chargeId
                                                }));

                                                handleSalesInputChange({ target: { value: selected } }, index, lineindex, "chargecode");
                                                setShowSalesSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));

                                                // ✨ NEW PART: split and set description separately ✨
                                                const splitParts = selected.split("-");
                                                const chargeCodeOnly = splitParts[0] || "";
                                                const descriptionOnly = splitParts.slice(1).join("-") || "";


                                                // Update charge code field value (CT002)
                                                setSalesInputValues((prev) => ({
                                                  ...prev,
                                                  [index]: {
                                                    ...prev[index],
                                                    [lineindex]: chargeCodeOnly,
                                                  },
                                                }));

                                                handleSalesInputChange({ target: { value: chargeCodeOnly } }, index, lineindex, "chargecode");

                                                // Update description field value (TestCharge)
                                                handleSalesInputChange({ target: { value: descriptionOnly } }, index, lineindex, "description");
                                              }}
                                              style={{
                                                padding: "8px",
                                                cursor: "pointer",
                                                borderBottom: "1px solid #eee",
                                              }}
                                            >
                                              {item.label}
                                            </li>
                                          ))}
                                        </ul>
                                      )}
                                      <span className="add-contract-tooltip">
                                        {salesInputValues[index]?.[lineindex]?.split("-")[0]?.trim()}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="table-tooltip-container">
                                      <input
                                        type="text"
                                        value={row.description}
                                        // readOnly={chargesNotEditable}
                                        onChange={(e) => {
                                          // if (chargesNotEditable) return;
                                          handleSalesInputChange(e, index, lineindex, "description");
                                        }}
                                        style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                        className="invoice_narrow_input_description"
                                      />
                                      <span className="add-contract-tooltip">
                                        {row.description}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="table-tooltip-container">
                                      <input
                                        type="number"
                                        value={row.po_wo_number}
                                        onInput={(e) => {
                                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                        }}
                                        onChange={(e) => {
                                          if (e.target.value.length <= 10) {
                                            handleSalesInputChange(e, index, lineindex, "po_wo_number");
                                          }
                                        }}
                                        className="invoice_narrow_input_quantity"
                                        style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                      />
                                      <span className="add-contract-tooltip">
                                        {row.po_wo_number}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <input
                                      type="date"
                                      value={row.po_wo_date}
                                      onChange={(e) => handleSalesInputChange(e, index, lineindex, "po_wo_date")}
                                      className="invoice_narrow_input_quantity"
                                      style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                    />
                                  </td>
                                  {/* SALES REMARKS */}
                                  <td>
                                    <div className="table-tooltip-container" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                      <input
                                        type="text"
                                        value={row.salesRemarks}
                                        onChange={(e) =>
                                          handleSalesInputChange(e, index, lineindex, "salesRemarks")}
                                        className="invoice_narrow_input_remarks"
                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                      />
                                      {row.salesRemarks?.trim() && (
                                        <SquarePen
                                          size={16}
                                          onClick={() =>
                                            openRemarkPopup("sales", index, lineindex, row.salesRemarks)
                                          }
                                        />
                                      )}
                                      <span className="add-contract-tooltip">
                                        {row.salesRemarks}
                                      </span>
                                    </div>
                                  </td>
                                  {/* SALES CONTRACT VALUE */}
                                  <td>
                                    <input
                                      type="number"
                                      value={row.salesContractValue}
                                      disabled
                                      // readOnly={chargesNotEditable}
                                      onChange={(e) => {
                                        // if (chargesNotEditable) return;
                                        handleSalesInputChange(e, index, lineindex, "salesContractValue");
                                      }}
                                      className="invoice_narrow_input"
                                      style={{ fontFamily: 'Work Sans' }}
                                    />
                                  </td>
                                  {/* SALES QUANTITY */}
                                  <td>
                                    <input
                                      type="number"
                                      value={row.SalesunitQuantity}
                                      // readOnly={chargesNotEditable}
                                      onChange={(e) => {
                                        // if (chargesNotEditable) return;
                                        handleSalesInputChange(e, index, lineindex, "SalesunitQuantity");
                                      }}
                                      className="invoice_narrow_input_quantity"
                                      style={{ fontFamily: 'Work Sans' }}
                                    />
                                  </td>
                                  {/* SALES RATE */}
                                  <td>
                                    <input
                                      type="number"
                                      value={row.salesRate}
                                      onChange={(e) => handleSalesInputChange(e, index, lineindex, "salesRate")}
                                      className="invoice_narrow_input"
                                      style={{ fontFamily: 'Work Sans' }}
                                    />
                                  </td>
                                  {/* SALES NET TOTAL */}
                                  <td>
                                    <input
                                      type="number"
                                      value={row.salesNetTotal}
                                      readOnly
                                      className="invoice_narrow_input"
                                      style={{ fontFamily: 'Work Sans' }}
                                    />
                                  </td>
                                  {/* SALES ATTACHMENT */}
                                  <td>
                                    <div className="file_upload_wrapper">
                                      {!row.salesUploadedFiles || row.salesUploadedFiles.length === 0 ? (
                                        row.salesAttachment ? (
                                          <div className="download_attachment_section" style={{ display: 'flex', justifyContent: 'center' }}>
                                            <button
                                              className="download_btn"
                                              onClick={() => window.open(row.salesAttachment, '_blank')}
                                              style={{ height: 'auto', width: 'auto', padding: '12px' }}
                                            >
                                              <img src={download_arrow} alt="Download" className="download_icon" />
                                              <span className="download_text">Download</span>
                                            </button>
                                            <button
                                              className="remove_file_btn"
                                              onClick={() => handleRemoveSalesAttachment(category.id, index, lineindex)}
                                            >
                                              ⨉
                                            </button>
                                          </div>
                                        ) : (
                                          <label className="file_upload" style={{ padding: '0px' }}>
                                            <input
                                              type="file"
                                              multiple
                                              onChange={(e) => handleSalesFileUpload(e, category.id, index, lineindex)}
                                              style={{ display: "none" }}
                                            />
                                            <img src={upload_icon} alt="Upload" className="upload_icon" />
                                            <span className="upload_text">Upload</span>
                                          </label>
                                        )
                                      ) : null}

                                      {row.salesUploadedFiles && row.salesUploadedFiles.length > 0 && (
                                        <div className="uploaded_files_list">
                                          {row.salesUploadedFiles.map((file, fileIndex) => (
                                            <div key={fileIndex} className="uploaded_file_item">
                                              <div className="file_info">
                                                <img
                                                  src={
                                                    file.name.match(/\.(xls|xlsx)$/i)
                                                      ? excel_icon
                                                      : upload_icon
                                                  }
                                                  alt="File type"
                                                  className="file_type_icon"
                                                />
                                                <span className="file_name">{file.name}</span>
                                              </div>
                                              <button
                                                className="remove_file_btn"
                                                onClick={() => handleRemoveSalesFile(category.id, index, lineindex, fileIndex)}
                                              >
                                                ⨉
                                              </button>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  </td>

                                  <td
                                    style={{
                                      position: 'sticky',
                                      right: 0,
                                      background: 'white',
                                      zIndex: 1,
                                      textAlign: 'center',
                                      padding: 0,
                                      boxShadow: '-2px 0 5px rgba(0,0,0,0.1)'
                                    }}
                                  >

                                    {/* {contract_id == null && ( */}
                                    <button onClick={() => deleteRow(category.id, lineindex, 'sales')} className="delete-btn">
                                      <img src={delete_icon} alt="Delete" />
                                    </button>
                                    {/* // )} */}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div
                            className="add_new_row"
                            onClick={() => addSalesRow(category.id)}
                            style={{ cursor: "pointer", width: '140px' }}
                          >
                            <span className="add_new_row_popup">
                              <img src={plus_icon} alt="" />
                              Add Sales Row
                            </span>
                          </div>
                        </div>
                      )}

                      {(getViewModeForCategory(category.id) === "split") && <DraggableDivider leftRef={salesRef} rightRef={costRef} />}

                      {(getViewModeForCategory(category.id) === "split" || getViewModeForCategory(category.id) === "cost") && (
                        <div className="table-containers cost-table" ref={costRef} style={{
                          position: 'relative', overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth', flex: getViewModeForCategory(category.id) === "split" ? "1 1 0px" : "1 1 100%",
                          width: getViewModeForCategory(category.id) === "split" ? "auto" : "100%", transition: 'flex 0.2s ease',
                          display: getViewModeForCategory(category.id) === "split" ? "block" :
                            (getViewModeForCategory(category.id) === "cost" ? "block" : "none")
                        }}>
                          <table className="invoice_table">
                            <thead>
                              <tr>
                                <th colSpan="13" style={{ backgroundColor: '#E0EFFF', color: '#097BED', padding: '8px' }}>COST</th>
                              </tr>
                              <tr>
                                <th style={{ backgroundColor: '#E0EFFF' }}>CHARGE CODE</th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>DESCRIPTION</th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>VENDOR</th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>VENDOR INV NUMBER</th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>VENDOR INV DATE</th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>PO/WO NO</th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>PO/WO Date</th>
                                <th style={{ backgroundColor: '#E0EFFF', padding: '10px' }}>REMARKS</th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>CONTRACT VALUE</th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>QUANTITY</th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>RATE</th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>NET TOTAL</th>
                                <th style={{ backgroundColor: '#E0EFFF' }}>ATTACHMENT</th>
                              </tr>
                            </thead>
                            <tbody>
                              {category.costRows.map((row, lineindex) => (
                                <tr key={lineindex}>
                                  <td style={{ position: "relative" }}>
                                    <div className="table-tooltip-container">
                                      <input
                                        type="text"
                                        style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                        value={costInputValues[index]?.[lineindex]?.split("-")[0]?.trim() || ""}
                                        onChange={(e) => {
                                          const val = e.target.value;
                                          handleCostInputChange(e, index, lineindex, "chargecode");
                                          setCostInputValues((prev) => ({
                                            ...prev,
                                            [index]: {
                                              ...prev[index],
                                              [lineindex]: val,
                                            },
                                          }));
                                          fetchCostSuggestions(val, lineindex, index);
                                        }}
                                        onFocus={() => {
                                          const list = costSuggestionsMap[index]?.[lineindex] || [];
                                          if (list.length > 0) {
                                            const list = costSuggestionsMap[index]?.[lineindex] || [];
                                            if (list.length > 0) {
                                              setShowCostSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: true }));
                                            }
                                          }
                                        }}
                                        onBlur={() => {
                                          setTimeout(() => {
                                            setShowCostSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));
                                          }, 200);
                                        }}
                                        className="invoice_narrow_input_chargecode"
                                        placeholder="Search"
                                      />

                                      {showCostSuggestionsMap[`${index}_${lineindex}`] && costSuggestionsMap[index]?.[lineindex]?.length > 0 && (
                                        <ul
                                          style={{
                                            position: "absolute",
                                            top: "100%",
                                            left: 0,
                                            right: 0,
                                            backgroundColor: "white",
                                            border: "1px solid #ccc",
                                            zIndex: 999,
                                            maxHeight: "150px",
                                            overflowY: "auto",
                                            margin: 0,
                                            padding: 0,
                                            listStyle: "none",
                                          }}
                                        >
                                          {costSuggestionsMap[index]?.[lineindex].map((item) => (
                                            <li
                                              key={item.value}
                                              onMouseDown={() => {
                                                const selected = item.label;
                                                const chargeId = item.value;

                                                setCostInputValues((prev) => ({
                                                  ...prev,
                                                  [index]: {
                                                    ...prev[index],
                                                    [lineindex]: selected,
                                                  },
                                                }));

                                                setSelectedCostChargeIds((prev) => ({
                                                  ...prev,
                                                  [`${index}_${lineindex}`]: chargeId
                                                }));

                                                handleCostInputChange({ target: { value: selected } }, index, lineindex, "chargecode");
                                                setShowCostSuggestionsMap(prev => ({ ...prev, [`${index}_${lineindex}`]: false }));

                                                // ✨ NEW PART: split and set description separately ✨
                                                const splitParts = selected.split("-");
                                                const chargeCodeOnly = splitParts[0] || "";
                                                const descriptionOnly = splitParts.slice(1).join("-") || "";


                                                // Update charge code field value (CT002)
                                                setCostInputValues((prev) => ({
                                                  ...prev,
                                                  [index]: {
                                                    ...prev[index],
                                                    [lineindex]: chargeCodeOnly,
                                                  },
                                                }));

                                                handleCostInputChange({ target: { value: chargeCodeOnly } }, index, lineindex, "chargecode");

                                                // Update description field value (TestCharge)
                                                handleCostInputChange({ target: { value: descriptionOnly } }, index, lineindex, "description");
                                              }}
                                              style={{
                                                padding: "8px",
                                                cursor: "pointer",
                                                borderBottom: "1px solid #eee",
                                              }}
                                            >
                                              {item.label}
                                            </li>
                                          ))}
                                        </ul>
                                      )}
                                      <span className="add-contract-tooltip">
                                        {costInputValues[index]?.[lineindex]?.split("-")[0]?.trim()}
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="table-tooltip-container">
                                      <input
                                        type="text"
                                        value={row.description}
                                        // readOnly={chargesNotEditable}
                                        onChange={(e) => {
                                          // if (chargesNotEditable) return;
                                          handleCostInputChange(e, index, lineindex, "description");
                                        }}
                                        style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                        className="invoice_narrow_input_description"
                                      />
                                      <span className="add-contract-tooltip">
                                        {row.description}
                                      </span>
                                    </div>
                                  </td>

                                  {/* COST VENDOR */}
                                  <td style={{ position: 'relative' }}>
                                    <div className="table-tooltip-container">
                                      <input
                                        type="text"
                                        className="contracts_small_input"
                                        style={{ margin: '0px', fontFamily: 'Work Sans', fontSize: '13px' }}
                                        value={vendorInputValues[`${index}_${lineindex}`] || ""}
                                        onChange={async (e) => {
                                          const val = e.target.value;
                                          setVendorInputValues(prev => ({
                                            ...prev,
                                            [`${index}_${lineindex}`]: val,
                                          }));

                                          if (val === "") {
                                            setSelectedVendorIds(prev => ({
                                              ...prev,
                                              [`${index}_${lineindex}`]: 0,
                                            }));
                                          }

                                          if (val.length >= 1) { // Changed from 2 to 1 to show suggestions immediately
                                            const suggestions = await fetchVendorSuggestions(val);
                                            setVendorSuggestions(suggestions);
                                            setShowVendorSuggestions(prev => ({
                                              ...prev,
                                              [`${index}_${lineindex}`]: true,
                                            }));
                                          } else {
                                            setShowVendorSuggestions(prev => ({
                                              ...prev,
                                              [`${index}_${lineindex}`]: false,
                                            }));
                                          }
                                        }}
                                        onFocus={async () => {
                                          const val = vendorInputValues[`${index}_${lineindex}`] || "";
                                          if (val.length >= 1) {
                                            const suggestions = await fetchVendorSuggestions(val);
                                            setVendorSuggestions(suggestions);
                                            setShowVendorSuggestions(prev => ({
                                              ...prev,
                                              [`${index}_${lineindex}`]: true,
                                            }));
                                          }
                                        }}
                                        onBlur={() => {
                                          setTimeout(() => {
                                            setShowVendorSuggestions(prev => ({
                                              ...prev,
                                              [`${index}_${lineindex}`]: false,
                                            }));
                                          }, 200);
                                        }}
                                        placeholder="Search vendor"
                                      />

                                      {showVendorSuggestions[`${index}_${lineindex}`] && vendorSuggestions.length > 0 && (
                                        <ul
                                          style={{
                                            position: "absolute",
                                            top: "100%",
                                            left: 0,
                                            right: 0,
                                            backgroundColor: "white",
                                            border: "1px solid #ccc",
                                            zIndex: 999,
                                            maxHeight: "150px",
                                            overflowY: "auto",
                                            margin: 0,
                                            padding: 0,
                                            listStyle: "none",
                                          }}
                                        >
                                          {vendorSuggestions.map((vendor) => (
                                            <li
                                              key={vendor.value}
                                              onMouseDown={() => {
                                                setVendorInputValues(prev => ({
                                                  ...prev,
                                                  [`${index}_${lineindex}`]: vendor.label,
                                                }));
                                                setSelectedVendorIds(prev => ({
                                                  ...prev,
                                                  [`${index}_${lineindex}`]: vendor.value,
                                                }));
                                                setShowVendorSuggestions(prev => ({
                                                  ...prev,
                                                  [`${index}_${lineindex}`]: false,
                                                }));
                                              }}
                                              style={{
                                                padding: "8px",
                                                cursor: "pointer",
                                                borderBottom: "1px solid #eee",
                                              }}

                                            >
                                              {vendor.label}
                                            </li>
                                          ))}
                                        </ul>
                                      )}
                                      <span className="add-contract-tooltip">
                                        {vendorInputValues[`${index}_${lineindex}`]}
                                      </span>
                                    </div>
                                  </td>

                                  {/* COST  REMARKS*/}
                                  <td>
                                    <div className="table-tooltip-container">
                                      <input
                                        type="text"
                                        className="invoice_narrow_input_remarks"
                                        style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                        value={row.vendor_inv_number || ""}
                                        onChange={(e) =>
                                          handleCostInputChange(e, index, lineindex, "vendor_inv_number")
                                        }
                                      />
                                      <span className="add-contract-tooltip">
                                        {row.vendor_inv_date || ""}
                                      </span>
                                    </div>
                                  </td>

                                  {/* COST  VENDOR DATE*/}
                                  <td>
                                    <div className="table-tooltip-container">
                                      <input
                                        type="date"
                                        className="invoice_narrow_input_remarks"
                                        style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                        value={row.vendor_inv_date || ""}
                                        onChange={(e) =>
                                          handleCostInputChange(e, index, lineindex, "vendor_inv_date")
                                        }
                                      />
                                      <span className="add-contract-tooltip">
                                        {row.vendor_inv_date || ""}
                                      </span>
                                    </div>
                                  </td>

                                  <td>
                                    <input
                                      type="number"
                                      value={row.po_wo_number}
                                      onInput={(e) => {
                                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                      }}
                                      onChange={(e) => {
                                        if (e.target.value.length <= 10) {
                                          handleCostInputChange(e, index, lineindex, "po_wo_number");
                                        }
                                      }}
                                      className="invoice_narrow_input_quantity"
                                      style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                    />
                                  </td>
                                  <td>
                                    <input
                                      type="date"
                                      value={row.po_wo_date}
                                      onChange={(e) => handleCostInputChange(e, index, lineindex, "po_wo_date")}
                                      className="invoice_narrow_input_quantity"
                                      style={{ margin: '0px', fontSize: '13px', fontFamily: 'Work Sans' }}
                                    />
                                  </td>
                                  {/* COST  REMARKS*/}
                                  <td>
                                    <div className="table-tooltip-container" style={{ display: "flex", alignItems: "center", gap: "6px" }}>

                                      <input
                                        type="text"
                                        value={row.costRemarks}
                                        onChange={(e) =>
                                          handleCostInputChange(e, index, lineindex, "costRemarks")}
                                        className="invoice_narrow_input_remarks"
                                        style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                      />
                                      {row.costRemarks?.trim() && (
                                        <SquarePen
                                          size={16}
                                          onClick={() =>
                                            openRemarkPopup("cost", index, lineindex, row.costRemarks)
                                          }
                                        />
                                      )}
                                      <span className="add-contract-tooltip">
                                        {row.costRemarks}
                                      </span>
                                    </div>
                                  </td>
                                  {/* COST CONTRACT VALUE */}
                                  <td>
                                    <input
                                      type="number"
                                      value={row.costContractValue}
                                      disabled
                                      // readOnly={chargesNotEditable}
                                      onChange={(e) => {
                                        // if (chargesNotEditable) return;
                                        handleCostInputChange(e, index, lineindex, "costContractValue");
                                      }}
                                      className="invoice_narrow_input"
                                      style={{ fontFamily: 'Work Sans' }}
                                    />
                                  </td>
                                  {/* COST QUANTITY */}
                                  <td>
                                    <input
                                      type="number"
                                      value={row.CostunitQuantity}
                                      // readOnly={chargesNotEditable}
                                      onChange={(e) => {
                                        // if (chargesNotEditable) return;
                                        handleCostInputChange(e, index, lineindex, "CostunitQuantity");
                                      }}
                                      className="invoice_narrow_input_quantity"
                                      style={{ fontFamily: 'Work Sans' }}
                                    />
                                  </td>
                                  {/* COST  RATE*/}
                                  <td>
                                    <input
                                      type="number"
                                      value={row.costRate}
                                      onChange={(e) => handleCostInputChange(e, index, lineindex, "costRate")}
                                      className="invoice_narrow_input"
                                      style={{ margin: '0px', fontFamily: 'Work Sans' }}
                                    />
                                  </td>
                                  {/* COST  NET TOTAL*/}
                                  <td>
                                    <input
                                      type="number"
                                      value={row.costNetTotal}
                                      readOnly
                                      className="invoice_narrow_input"
                                      style={{ fontFamily: 'Work Sans' }}
                                    />
                                  </td>

                                  {/* COST  ATTACHMENT*/}
                                  <td>
                                    <div className="file_upload_wrapper">
                                      {!row.costUploadedFiles || row.costUploadedFiles.length === 0 ? (
                                        row.costAttachment ? (
                                          <div className="download_attachment_section" style={{ display: 'flex', justifyContent: 'center' }}>
                                            <button
                                              className="download_btn"
                                              onClick={() => window.open(row.costAttachment, '_blank')}
                                              style={{ height: 'auto', width: 'auto', padding: '12px' }}
                                            >
                                              <img src={download_arrow} alt="Download" className="download_icon" />
                                              <span className="download_text">Download</span>
                                            </button>
                                            <button
                                              className="remove_file_btn"
                                              onClick={() => handleRemoveCostAttachment(category.id, index, lineindex)}
                                            >
                                              ⨉
                                            </button>
                                          </div>
                                        ) : (
                                          <label className="file_upload">
                                            <input
                                              type="file"
                                              multiple
                                              onChange={(e) => handleCostFileUpload(e, category.id, index, lineindex)}
                                              style={{ display: "none" }}
                                            />
                                            <img src={upload_icon} alt="Upload" className="upload_icon" />
                                            <span className="upload_text">Upload</span>
                                          </label>
                                        )
                                      ) : null}

                                      {row.costUploadedFiles && row.costUploadedFiles.length > 0 && (
                                        <div className="uploaded_files_list">
                                          {row.costUploadedFiles.map((file, fileIndex) => (
                                            <div key={fileIndex} className="uploaded_file_item">
                                              <div className="file_info">
                                                <img
                                                  src={
                                                    file.name.match(/\.(xls|xlsx)$/i)
                                                      ? excel_icon
                                                      : upload_icon
                                                  }
                                                  alt="File type"
                                                  className="file_type_icon"
                                                />
                                                <span className="file_name">{file.name}</span>
                                              </div>
                                              <button
                                                className="remove_file_btn"
                                                onClick={() => handleRemoveCostFile(category.id, index, lineindex, fileIndex)}
                                              >
                                                ⨉
                                              </button>
                                            </div>
                                          ))}
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      position: 'sticky',
                                      right: 0,
                                      background: 'white',
                                      zIndex: 1,
                                      textAlign: 'center',
                                      padding: 0,
                                      boxShadow: '-2px 0 5px rgba(0,0,0,0.1)'
                                    }}
                                  >
                                    <button onClick={() => deleteRow(category.id, lineindex, 'cost')} className="delete-btn">
                                      <img src={delete_icon} alt="Delete" />
                                    </button>

                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          <div
                            className="add_new_row"
                            onClick={() => addCostRow(category.id)}
                            style={{ cursor: "pointer", width: '140px' }}
                          >
                            <span className="add_new_row_popup">
                              <img src={plus_icon} alt="" />
                              Add Cost Row
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>

      <ConfirmDialog
        open={openConfirm}
        title="Confirm Job Submission"
        message="Are you sure you want to submit the job?"
        confirmText="Submit"
        cancelText="Cancel"
        onConfirm={() => {
          if (isSubmitting) return;
          setOpenConfirm(false);
          performSubmit(pendingAction);
        }}
        onCancel={() => setOpenConfirm(false)}
      />
      <ConfirmDialog
        open={openConfirmUpdate}
        title="Confirm Job Update"
        message="Are you sure you want to submit the updated job?"
        confirmText="Submit"
        cancelText="Cancel"
        onConfirm={() => {
          if (isSubmitting) return;
          setOpenConfirmUpdate(false);
          performUpdate(pendingUpdateAction);
        }}
        onCancel={() => setOpenConfirmUpdate(false)}
      />
      <CommonFooter />
      <CommonRemarkPopup
        show={showRemarkPopup}
        onClose={() => setShowRemarkPopup(false)}
        onSave={handleSaveRemark}
        initialValue={remarkValue}
        title={
          remarkMeta?.type === "cost"
            ? "Cost Remarks"
            : "Sales Remarks"
        }
      />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  )
}

export default Jobs_addnew
